export default {
    "accountValidateMsg" : "Hesap, harfler, rakamlar ve semboller dahil olmak üzere 6 - 30 karakter içermelidir (\".\", \"_\", \"@\"). İlk karakter rakam veya harf olmalıdır.",
    "storeSuccess" : "Yükleme Başarılı",
    "editAccountTips" : "Lütfen geçerli bir hesap adı girin",
    "editPwdTips" : "Lütfen geçerli bir şifre giriniz",
    "editRepeatPwdTips" : "Lütfen şifrenizi tekrar giriniz",
    "pwdRepeatTips" : "Şifreler uyuşmuyor",
    "changePwdSucc" : "Şifreniz değiştirildi",
    "bindEmail" : "E-postayı Bağla",
    "errorVrifyCodeTips" : "Doğrulama kodu hatası",
    "slectQuessionTips" : "Lütfen bir güvenlik sorusu seçin?",
    "answerTips" : "Lütfen cevabı giriniz",
    "twoAnswerTips" : "Lütfen oluşturulan güvenlik sorularını seçin ve doğru cevapları girin",
    "realNameValidateTips" : "Gerçek ad (4 - 60 karakter)",
    "phoneValidateTips" : "Telefon Numarası (6 - 18 hane)",
    "areaSelectTips" : "Lütfen bölge seçiniz",
    "iDCardValidataTips" : "Kimlik Numarası (1 - 60 hane)",
    "changeProfileSucc" : "Güncellenen bilgi kaydedildi",
    "editVrfCodeTips" : "Lütfen doğrulama kodunu girin",
    "securityQuestionTips" : "Lütfen hesap güvenliğinizi artırmak için güvenlik soruları oluşturun. Şifrenizi unuttuğunuzda, şifreyi sıfırlamak için soruları cevaplayabilirsiniz.",
    "validateQuessionTips" : "Lütfen iki farklı soru seçin ve doğrulayın. Doğrulamadan sonra soruları yeniden oluşturabilirsiniz.",
    "originPwd" : "Orijinal Şifre",
    "newPwd" : "Yeni Şifre",
    "changePwdSuccess" : "Şifre değişti. İlerlemenizi kaydetmek için şimdi tekrar giriş yapmanızı öneririz.",
    "accountName" : "Hesap adı",
    "password" : "Şifrenizi giriniz",
    "repeatPassword" : "Lütfen şifrenizi tekrarlayın",
    "findPwdTips" : "Lütfen şifresini geri almak istediğiniz hesabı girin.",
    "submit" : "Gönder",
    "send" : "Gönder",
    "modify" : "değiştir",
    "haveAgree" : "Onay",
    "and" : "ve",
    "privacyPolicy" : "Gizlilik Politikası",
    "completeness" : "Tamamlama",
    "gender" : "Cinsiyet",
    "male" : "erkek",
    "female" : "kadın",
    "birthday" : "Doğum günü",
    "phone" : "Telefon",
    "region" : "Bölge",
    "ID" : "Kimlik",
    "accountSetting" : "Hesap Ayarları",
    "upgrade" : "Yükselt",
    "profile" : "Profil",
    "changePassword" : "Şifre Değiştir",
    "securityQuestion" : "Güvenlik Soruları",
    "creatework_headerTitle" : "Bilet Oluştur",
    "mylist_headerTitle" : "Biletim",
    "bindEmailTips" : "Hesabınızın güvenliği için e-postanızı doğrulayın. Şifrenizi unuttuysanız, bu e-posta adresine bir posta göndereceğiz.",
    "enterEmailVrfcationTips" : "Lütfen doğrulama kodunu buraya giriniz.",
    "cancel" : "İPTAL",
    "bindTps" : "Oyunu birden fazla cihazda oynamak için hesabınızı bağlayın!",
    "login" : "Giriş yap",
    "logout" : "Çıkış yap",
    "bind" : "Hesabı Bağla",
    "feedback" : "Geri Bildirim",
    "terms" : "Anlaşmalar",
    "tips" : "Bildiri",
    "debindTips" : "Bağlantıdan çıkarma işlemi veri kaybına neden olabilir. Devam?",
    "debindText" : "Bağlantıdan çıkar",
    "guestSwitchTips" : "Misafir hesabı tespit edildi. Giriş yaptıktan sonra misafir hesap verileriniz kaybolacak. Devam et?",
    "register" : "KAYDOL",
    "realName" : "gerçekAd",
    "enterEmailTips" : "Lütfen e-posta adresinizi giriniz",
    "emailVAlidateMsg" : "geçersiz e posta",
    "editEmaileTips" : "lütfen e-posta adresinizi giriniz",
    "checkServiceTips" : "Lütfen önce Kullanım Koşulları ve Gizlilik Politikası\'nı okuyun.",
    "brithdayValidateTips" : "Doğum tarihinizi girin",
    "facebookValidateTips" : "Facebook Hesabı (1 - 60 karakter)",
    "eritOriginPwdTips" : "Orijinal şifre",
    "submitSuccess" : "Submitted",
    "rebindEmail" : "Bağlı E-postayı Değiştir",
    "bindEmailSuccess" : "E-posta bağlandı: \$email</br>Lütfen doğrulamak için bağlı bir e-posta kullanın. Doğrulamadan sonra e-postanızı sıfırlayabilirsiniz.",
    "reSetSecurityQuessoon" : "Güvenlik sorularını başarıyla oluşturdunuz </br></br>Lütfen farklı sorular seçin ve doğrulayın. Doğrulamadan sonra soruları yeniden oluşturabilirsiniz.",
    "canotModifyTips" : "Gönderimden sonra değişiklik yapılmasına izin verilmemektedir.",
    "rebindEmailTips" : "E-posta adresiniz: \$email, doğrulama kodunu almak için lütfen buraya dokunun",
    "reGetVrfCode" : "Kod Al",
    "findPwdWayTips" : "Lütfen aşağıdaki yollardan birini seçin",
    "emailWay" : "Güvenlik e-postasıyla geri alın",
    "emailWayTips" : "Bir onay e-postası alacaksınız ve şifreyi sıfırlayabileceksiniz.",
    "quessionWay" : "Güvenlik sorularıyla geri alın",
    "quessionWayTips" : "Answer the created security questions and then reset the password",
    "resetPwdBtn" : "Reset the password",
    "lastStep" : "Previous",
    "sendEmailTips" : "\$email\'a bir e-posta gönderdik.<br>Lütfen buraya aldığınız doğrulama kodunu girin.",
    "setNewPwdTips" : "Tebrikler!<br>Kullanıcı kimliği doğrulandı. Şimdi şifrenizi sıfırlayabilirsiniz.",
    "termsOfUse" : "Kullanım Şartları",
    "copy_success" : "Kopyalandı",
    "creatework_create" : "Bilet",
    "creatework_createHolder" : "Tür Seç",
    "creatework_title" : "Konu",
    "creatework_titleHolder" : "Lütfen bir konu girin",
    "creatework_detail" : "Ayrıntılar",
    "creatework_detailHolder" : "Açıklama 200\'den fazla karakter içermemelidir",
    "creatework_uploadTips" : "Lütfen sadece jpg/png dosyalarını yükleyin. Yüklenen dosya 5 MB\'tan küçük olmalıdır.",
    "creatework_selectBox_selectTile" : "Tür",
    "creatework_goGame" : "Geri",
    "creatework_history" : "Geçmiş",
    "mylist_noYet" : "Kayıt yok",
    "mywork_solved" : "Sorun çözüldü mü?",
    "mywork_service" : "Bize puan verin",
    "mywork_messageHolder" : "Yeni mesaj",
    "mywork_score" : "Skor",
    "mywork_confirm" : "ONAY",
    "creatework_selectBox_selectList3" : "Diğer",
    "creatework_selectBox_selectList2" : "Hesap",
    "close" : "Kapat",
    "creatework_gameHolder" : "Oyun Seçin",
    "creatework_serverHolder" : "Sunucu seçin",
    "contactService" : "Destek Ekibimize Ulaşın",
    "FAQ" : "FAQ",
    "creatework_game" : "Oyun:",
    "creatework_server" : "Sunucu:",
    "creatework_role" : "Karakter:",
    "selectRoleName" : "Karakter Seç",
    "creatework_noRole" : "Karakter yok",
    "creatework_noGame" : "Oyun listesi boş",
    "creatework_noServer" : "Sunucu listesi boş",
    "termText" : "{mainHost} koşullarını kabul ediyorum",
    "backLogin" : "REDDET",
    "creatework_roleHolder" : "Karakterinizi seçtikten sonra giriş yapın.",
    "findPwdFailTips" : "Güvenlikle ilgili soruları belirlemediniz. Lütfen müşteri hizmetleri ile iletişime geçin.",
    "payMall" : "AVM",
    "selectPayment" : "Miktar",
    "plzSelectPayWay" : "Kanal Seç",
    "gainPlus" : "Ekle",
    "gainMorePlus" : "Daha fazla ekle",
    "gainMostPlus" : "Maks",
    "plzSelectPayType" : "Ödeme Yöntemi Seç",
    "roleName" : "Karakter",
    "payWay" : "Ödeme Kanalı",
    "plzSelectOtherWay" : "Altarnatif Ödeme Kanalı",
    "payment" : "Miktar",
    "compensateTips" : "Fazlalık size \$gameCode içinde gönderilecektir",
    "extaGain" : "Bonus",
    "gameGold" : "Oyun-içi Para",
    "compensate" : "Telafi",
    "payWayPlus" : "Kanal Bonusu",
    "neddPay" : "Ödeme",
    "submitOrder" : "Gönder",
    "screenshotTips" : "Bildiri: Bir işlem hatası durumunda siparişinizin ekran görüntüsünü alın.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "İşlem başarısız. Lütfen tekrar sipariş verin veya müşteri hizmetlerimizle iletişime geçin.",
    "storeAcceptance" : "İşlem gerçekleşiyor",
    "storeSuccessTips" : "Transaction shall be done in 15 mins.",
    "orderNumber" : "Sipariş No.",
    "buyProduct" : "Yükleme Öğesi",
    "transactionAmount" : "Miktar",
    "failReason" : "Sebep",
    "payOntherORder" : "Yeni Sipariş",
    "reStore" : "Tekrar Yükle",
    "confirm" : "Onayla",
    "switch" : "Hesap Değiştir",
    "completeTips" : "Lütfen kişisel bilgilerinizi girin. <mark class=\"yellowMarkColor\">Bilgiler değiştirilemez</mark>. Kayıp bir hesabınızı geri almaya çalışırken, kişisel bilgilerinizi hatasız girmeniz istenecek.",
    "creatework_selectBox_selectList0" : "Oyun Hatası",
    "creatework_selectBox_selectList1" : "Ödeme hatası",
    "creatework_selectBox_selectList4" : "Çeviri hatası",
    "mywork_solvedText" : "Sorun çözüldü",
    "browserPayErrBtnText" : "Ödeme hatası",
    "browserPaySucBtnText" : "Ödeme tamamlandı",
    "browserPayingTips" : "Üçüncü parti platformuna yönlendiriliyor.<br/>Ödemeden sonra bu sayfa kapatılabilir.",
    "price_list_empty" : "Uygulanabilir miktar yok",
    "pointCardTips" : "Not: Bu öğe yalnızca \$paymentAmount kartı kabul etmektedir",
    "forgetPwd" : "Şifrenizi mi unuttunuz?",
    "payCenter" : "Yükleme Merkezi",
    "willGet" : "Alacaksınız",
    "goods" : "Öğe",
    "discount" : "Bonus",
    "payDiscount" : "Telafi",
    "payDiscountTips" : "Fazlalık miktarı ilgili para biriminde iade edilecektir.",
    "hasQuestionPlease" : "Herhangi bir sorunuz varsa lütfen",
    "pwdValidateMsg" : "6 ila 20 karakter",
    "payWayPlusC" : "Kanal Bonusu",
    "fwtk" : "KULLANIM ŞARTLARI",
    "yszc" : "GİZLİLİK POLİTİKASI",
    "exchange" : "Hediye kodu değişimi",
    "remember" : "Seçimimi hatırla",
    "thirdInfo" : "Hesap hakkında",
    "thirdInfoContent" : "Lütfen hesabınızı oyun içi Kullanıcı Merkezinde bağlayın. Daha sonra, bağlı hesabı kullanarak oyuna giriş yapın.",
    "unLink" : "Bu yöntem şu anda desteklenmiyor",
    "favour" : "Yer imi",
    "goStoreTip" : "Lütfen ödeme sayfasına gidin",
    "go" : "Git",
    "otherLogin" : "Diğer giriş yöntemleri",
    "qrCodeTip" : "Başlamak için QR kodunu tarayın!",
    "favourTip" : "Daha sonra tekrar oynamak için sayfayı işaretleyin!",
    "share" : "Paylaş",
    "landscapeTip" : "Lütfen portre modunda devam edin",
    "leaveTip" : "Oyundan çık?",
    "selectRole" : "Lütfen karakter seçin",
    "selectMoney" : "Lütfen yükleme miktarını seçin",
    "seletGameInfoFirst" : "Lütfen oyun seçin",
    "lowerIE" : "IE version too old",
    "linkTermText" : "I have accepted {mainHost} [Terms of Use] and [Privacy Policy]",
    "download" : "Download",
    "favourAndDownloadTip" : "Bookmark this page to browser or download on PC",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "countryCode" : "Country code",
    "deleteaccount_title1" : "Delete Account",
    "deleteaccount_title2" : "Request account deletion",
    "deleteaccount_step1_1" : "Your account will be frozen for 14 days since the account deletion. After 14 days, your account will be permanently deleted. You will not be able to log in with other social accounts.",
    "deleteaccount_step1_2" : "You may revoke the deletion within the 14 days through the link below:",
    "deleteaccount_step1_3" : "Once deleted, you will not be able to restore your account information. You will not be compensated for any loss caused by account deletion.",
    "deleteaccount_step1_4" : "Are you sure you want to delete your account?",
    "deleteaccount_step2_1" : "Please confirm that you want to delete your account and character.",
    "deleteaccount_step2_2" : "Please type \\&quot;Delete\\&quot; to complete the deletion.",
    "deleteaccount_step3" : "Your account will be deleted in 14 days.",
    "accountrecovery_note" : "Note:",
    "accountrecovery_tips" : "You may only revoke account deletion during the 14-day frozen period.",
    "accountrecovery_Submitted2" : "Revocation submitted. Your account will be restored later.",
    "accountrecovery_Failed" : "Failed",
    "accountrecovery_Failed_1" : "Account status is normal. You may log in.",
    "accountrecovery_Failed_2" : "Character information not found.",
    "accountrecovery_success" : "Account restored",
    "account_normal" : "Account status is normal. No need to restore.",
    "account_unablerestore" : "Account has been deleted. Unable to restore.",
    "accountrecovery_roleHolder" : "Enter  your character name",
    "accountrecovery_headerTitle" : "Revoke Account Deletion",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Account Recovery",
    "inputAccount" : "Please enter the account name that you wish to recover",
    "applyForAccountFix" : "Account Recovery",
    "nonEnterItem" : "Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks",
    "resetOT" : "Time out, please submit the Review again",
    "addOT" : "Time out, please submit the Additional Information again",
    "errorPwd" : "Password has to be 6-20 characters, including letters, numbers, \".\", \"_\", \"@\"",
    "verifyAccount" : "Account info is missing, please check again.",
    "selectRegisterTime" : "Please choose your registration time.",
    "enterBindEmail" : "Please insert your verified email.",
    "enterUsedPhoneType" : "Please insert the model of your mobile phone.",
    "enterIdfaGpid" : "Please insert the UDID of your device.",
    "enterContactEmail" : "Incorrect format of Contact E-mail Address; Please re-enter",
    "confirmTermsPrivacy" : "Please read and agree to the service terms and privacy policy.",
    "enterRechargeRemark" : "Please insert your recharge record.",
    "uploadImg" : "Please upload an Image Scan of your ID, maximum size is 20MB",
    "selectIDType" : "Please select the type of your identification document.",
    "enterIDNum" : "Please insert your passport number or ID number.",
    "enterIP" : "Please insert the IP address you used for registration.",
    "enterQueryNum" : "Please enter Review ID",
    "enterQueryPwd" : "Please enter Review Password",
    "errorQueryItem" : "Incorrect Review ID or Password, please try again",
    "enterPassword" : "Please insert a new password.",
    "enterPasswordAgain" : "Please confirm your new password.",
    "enterPasswordNonSame" : "Inconsistent Password",
    "enterEmail" : "Please enter e-mail address",
    "sendSuccess" : "E-mail has been sent",
    "enterCode" : "Please enter the Verification Code",
    "errorCode" : "Incorrect verification code",
    "selectQuest" : "Please select a Security Question",
    "enterAnswer" : "Please enter the answer",
    "selectDifferQuest" : "Please select 3 Security Questions and answers",
    "addSuccess" : "Your information has been submitted.",
    "picFormt" : "Picture format must be jpg, png or gif",
    "countdownBefore" : "Reset Countdown",
    "countdownAfter" : "(The link will expire at 00:00:00, please submit your application again )",
    "uploadDone" : "Upload done",
    "uploadFail" : "Upload failed",
    "applySuccess" : "Application Approved",
    "applyFailed" : "Application Denied",
    "resetQuestAlterFailed" : "Failed to change security question.",
    "resetQuestError" : "Data input error.",
    "resetQuestNone" : "Inquiry order not found.",
    "resetQuestAltered" : "Security questions have been changed.",
    "illegalOperation" : "Illegal Operation",
    "queryNotExist" : "Inquiry number does not exist.",
    "queryPasswordError" : "Find Password Error",
    "auditing" : "Pending approval",
    "notPass" : "Denied",
    "suppleInformation" : "Submit supplementary information",
    "suppleInformationUnHandle" : "Supplementary information submitted, pending process.",
    "suppleInformationTimeout" : "Submit supplementary information timeout.",
    "repairedAccountSuccess" : "Account repair has been completed.",
    "repairedAccountLost" : "Account repair operation has failed.",
    "loginStateNone" : "Not logged in or session has expired.",
    "repairedAccountTimeout" : "Account repair duration has expired.",
    "changePasswordSucc" : "Password changed.",
    "emailSendFailed" : "Failed to send mail.",
    "emailSendLimit" : "The mailbox may not receive any more verification codes today.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "E-mail verification code has been sent.",
    "alterSuccess" : "Change saved",
    "questionAlterSuccess" : "Security question has been changed.",
    "username" : "Account name",
    "code" : "Please enter the verification code here",
    "selectServiceType" : "Please select Service Type",
    "submitForm" : "Submit the Form",
    "apply" : "Apply",
    "reviewApplicationStatus" : "Review Application Status",
    "instantReviewOfTheStatus" : "Instant Review of the Status",
    "reviewStatus" : "Review Status",
    "backToLogin" : "Back to login",
    "previous" : "Previous",
    "applyDesc" : "Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter \"None\".",
    "additionalServices" : "Additional Services",
    "resetSecurityEmail" : "Reset Security E-mail",
    "resetSecurityQuest" : "Reset Security Questions",
    "registrationDate" : "Registration Date",
    "month" : "Month",
    "year" : "Year",
    "emailBound" : "E-mail Bound",
    "modelNumber" : "Mobile model type;",
    "deviceName" : "Device Name",
    "provideRecharge" : "Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.",
    "selectCountry" : "Region",
    "passportID" : "Passport/ ID",
    "upload" : "Upload",
    "del" : "delete",
    "pleaseUpload" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadAgain" : "Upload again",
    "enterDesc" : "Please enter any information that proves the ownership of the account",
    "contactEmail" : "Contact E-mail",
    "applyNoteAttr" : "Note",
    "applyNoteDate" : "please provide your e-mail address so that you can receive the results of your application",
    "agree" : "I have agreed to",
    "UJOYTerms" : "Terms of Use",
    "privacy" : "Privacy Policy",
    "reviewStatusOfAccountFix" : "Review Status of Account Fix",
    "enterReviewID" : "Please enter Review ID",
    "enterReviewPwd" : "Please enter Review Password",
    "review" : "Review",
    "reviewNoteAttr" : "Note",
    "reviewNoteData" : "Check your Contact E-mail in case you forgot the Review ID and Review Password",
    "haveResetInfo" : "You\'ve reset your info",
    "resetProfile" : "Reset your Profile",
    "desc" : "Congrats! Application approved! Please reset your profile.",
    "changePwd" : "Change Password",
    "resetPwd" : "Reset Password",
    "reset" : "Reset",
    "enterNewPwd" : "Please enter new password",
    "confirmNewPwd" : "Please confirm new password",
    "successResetPwd" : "Successfully Reset password",
    "bindSecurityEmail" : "Bind Security E-mail",
    "resetPwdDesc" : "Reset password when you forgot password or account was stolen",
    "bindCommon" : "Bind",
    "sendCommon" : "Send",
    "enterVcode" : "Please enter the Verification Code",
    "successResetEmail" : "Successfully Reset Security E-mail",
    "resetQuest" : "Reset Security Questions",
    "resetQuestDesc" : "Reset password when you forget your password or you believe your account info was stolen",
    "successResetQuest" : "Successfully Reset Security Questions",
    "hide" : "Hide",
    "addRegisterTime" : "Registration time;",
    "modelNum" : "Model Number: IDFA/GPID",
    "registrationIP" : "Registration IP;",
    "addRechargeRecord" : "Recharge record;",
    "serviceReply" : "Reply from Customer Service:",
    "addDataLimitTime" : "Date for Adding Addititional Information:",
    "addMoreInfo" : "Add More Information",
    "applicationSubmit" : "Application submitted",
    "underReviewStatus" : "Your profile is under review, you will get reply in the next working day. Review status:",
    "reviewID" : "Review ID",
    "reviePwd" : "Review Password",
    "enterReviewIDNPwd" : "Enter Review ID and Review Password to check status",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Note",
    "checkEmailData" : "Check your Contact E-mail in case you forgot your Review ID and Review Password",
    "underReview" : "Under Review",
    "underReviewReply" : "Your profile is under review.We will reply as soon as possible. Thank you for your patience!",
    "failed" : "Application Failed",
    "reason" : "Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!",
    "underReviewAdd" : "Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!",
    "addInfoRequired" : "Additional Information Required",
    "dateForAddInfo" : "Date for Adding Addititional Information:",
    "addInfo" : "Additional Information",
    "addInfoSubmit" : "Additional Information has been submitted! Thank you for your patience!",
    "hasBeenRepaired" : "Account has been repaired",
    "opExpired" : "Account repair operation expired",
    "approved" : "Approved",
    "haveSubmitted" : "You\'ve submitted",
    "sessionExpired" : "You\'ve not yet logged in or session value has expired",
    "submitted" : "Submitted",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Inconsistent ID Number;",
    "addItemIDPhoto" : "ID Photo;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadTipsBefore" : "File size must not be greater than",
    "uploadTipsAfter" : "M",
    "submitError" : "Error caused by missing ID number or wrong account info.",
    "applyLimitError" : "Daily application limit exceeded. (3 times each day)",
    "applyDisabled" : "You may only submit once every 10 minutes.",
    "inputDataError" : "Data is not completed.",
    "dataException" : "Data exception",
    "picSizeLimit" : "Picture file size must not exceed 5MB",
    "picTypeLimit" : "Upload JPG, PNG, GIF files only",
    "picNull" : "Picture is empty",
    "alteredPassword" : "Password has been changed.",
    "inputError" : "Input error.",
    "pwdChangefailed" : "Failed to change password.",
    "sendEmailCodeDisabled" : "Verification code can only be sent again after a period of time.",
    "alteredEmail" : "E-mail has been changed.",
    "inputEmailError" : "E-mail input error",
    "operationFailed" : "Operation failed",
    "codeNull" : "You have not entered a verification code yet.",
    "findPwd" : "Forgot password",
    "findAccountAndPwd" : "Forgot account/password",
    "usualDeviceNum" : "Model Number: IDFA/GPID",
    "usualPhoneNum" : "Device Name",
    "registerTimeError" : "Inconsistent Registration Date;",
    "bindEMailError" : "Inconsistent Bound E-mail;",
    "rechargeRecordError" : "Inconsistent Recharge Record;",
    "registerIPError" : "Inconsistent Registration IP address;",
    "deviceNumError" : "Inconsistent IDFA/GPID;",
    "deviceModelError" : "Inconsistent Device Model;",
    "confirmTerms" : "Please agree to terms of service",
    "applyFixAccount" : "Bu yöntemlerden hiçbiri işe yaramazsa, <span>hesabı geri alma</span> talebinde bulunabilirsiniz.",
    "findPwdByFixAccount" : "You are advised to set a security e-mail for account recovery.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Bookmark to browser! (This account has claimed the reward already)",
    "h5_favour_get_gift" : "Congrats! You obtained the reward. Please check in-game.",
    "h5_get_gift_fault" : "Unable to claim. Please try again later, and contact our CS if the problem remains.",
    "h5_favour_please_select" : "Please choose server/character",
    "h5_favour_login_get" : "Log in and bookmark to the browser to claim a reward!",
    "h5_favour_tip" : "Bookmark to the browser to claim a reward!",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "Seçilen öğeyi bu ödeme yöntemi ile satın alamazsınız.",
    "SwitchWithThirdWay" : "Switch to \${type}",
    "moreGame" : "Daha fazla oyun",
    "serviceTitle" : "Service",
    "h5_download_login" : "Please log in first.",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "You have claimed this giftpack.",
    "h5_download_succ" : "Please download the client first.",
    "h5_download_repeat_role" : "Character is bound",
    "currentLoginAccount" : "Current account:",
    "fb_canvas_fullscreen" : "Expand",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Share",
    "fb_canvas_service" : "Support",
    "fb_canvas_login_fail" : "Login failed",
    "fb_canvas_pay_return" : "You have cancelled the transaction",
    "fb_canvas_root_tip" : "Please log in Facebook to authorize first",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "within the 14 days. Revoke now?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Are you sure you want to delete the account along with its data?",
    "account_delete_fwq" : "Server",
    "account_delete_zhm" : "Character",
    "account_delete_jshflj" : "Character retrieval link",
    "account_delete_qzyzmdxx" : "(Case sensitive)",
    "account_delete_jtbcysxx" : "You are advised to take a screenshot of the above information for account retrieval.",
    "deleteaccount_step3_2" : "After 14 days, your account will be deleted. You will not be able to restore your account. You will lose all your account information.\n\nYou may revoke the account deletion through",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "questionnaire investigation",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "Ödül Bilgisi",
    "yourServer" : "Sunucunuz",
    "allServer" : "Tüm Sunucular",
    "h5_header_screen" : "Tam Ekran",
    "h5_verticalTip" : "Manzara modu tavsiye edilir.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Recent",
    "moreGames" : "More",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "default",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Payment Method Bonus\nBonus currency = Amount paid*currency rate * bonus rate x Payment Method Bonus\nBonus currency = Amount paid*currency rate * bonus rate\n*Note: bonus currency will not be counted by top-up events or VIP EXP.*For games that are launched globally,the payment amount is calculated in us dollars.Please contact customer service if you have any questions.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "If you chose to save your card number on the previous page, we would collect the data of your card  (**** **** **** 1234) in encrypted version.",
    "quickcard_result_tip_two" : "We store encrypted details only for your convenience, and you do not have to input card numbers at your next purchase.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Stored Credentials Statements",
    "quickcard_info_tip_one" : "To better protect customer data security, Visa and Mastercard are introducing new definitions for these \"stored credentials\", and new rules for stored credential and merchant initiated transactions.",
    "quickcard_info_tip_two" : "When you make a purchase on our website, we collect the data of your card (1234 **** **** 1234) in encrypted version. We will hold the encrypted details for 4 years and will update the agreement, privacy policy on our website in case there are any changes. We store encrypted details only for your convenience, and you do not have to input card numbers at your next purchase.",
    "search_product" : "find item",
    "search_price" : "find price",
    "price" : "price",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Lütfen karakter seç",
    "storeSocialLogin" : "SAS hesabı ile giriş yap",
    "storeAccountIdLogin" : "Hesap Kimliği ile giriş yap",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Ara",
    "storeSelectProductTitle" : "Öğeleri Seç",
    "storeInputNameSearch" : "Eşya adı gir ve ara",
    "storeInputPriceSearch" : "Eşya fiyatı gir ve ara",
    "storeNoFindProduct" : "Eşya bulunamadı. Tekrar deneyin.",
    "storePriceUp" : "Fiyat↑",
    "storePriceDown" : "Fiyat↓",
    "storeLookDetail" : "Ayrıntılar",
    "storeChangeProduct" : "Eşyayı değiştir",
    "storeWelcome" : "Hoşgeldin",
    "storeLookMore" : "Daha fazlası",
    "storeHasSelect" : "Seçilen eşyalar",
    "storeTotal" : "Toplam",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Ayrıntılar",
    "storeUidGuideStep1" : "Ayarlar > Dahası > Hesapla diye tıkla",
    "storeUidGuideStep2" : "Yükleme yaprken hesap kimliğ girin",
    "storeSelectAndLook" : "Lütfen öncelikle karakterinizi seçin",
    "storeSwitchWay" : "Giriş Metodunu değiştir",
    "type1" : "Günlük İndirim",
    "type2" : "Kahraman",
    "type3" : "Savaş Teçhizatı",
    "type4" : "",
    "type5" : "Çip",
    "type6" : "Nova",
    "type7" : "Kaynak",
    "type8" : "İnşa Hızlandırma",
    "type9" : "Nadir Öğeler",
    "type10" : "İttifak",
    "type11" : "Elmas",
    "type12" : "Modül",
    "type13" : "Küp",
    "type14" : "",
    "type15" : "Nano Silah",
    "type16" : "Büyük Ödül",
    "type17" : "",
    "type9999" : "Sınırlı Teklif",
    "type10000" : "Hediye Merkezi",
    "type10001" : "Tatil Etkinlikleri",
    "typeother" : "Diğer Ürünler",
    "switchChar" : "Karakter Değiştir",
    "howToFindUid" : "Hesap Kimliğimi nereden bulurum?",
    "choosePayWay" : "Bir ödeme yöntemi seç",
    "new_apple_deleteaccount_stepsub_title" : "Otomatik Yenilemeyi İptal Et",
    "new_apple_deleteaccount_stepsub_1" : "Hesabınızın altında bir otomatik yenileme aboneliği bulunur. İstenmeyen satın almalardan kaçınmak için hesabınızı silmeden önce otomatik yenilemeyi iptal etmeniz önerilir.",
    "new_apple_deleteaccount_stepsub_2" : "Otomatik Yenilemeyi İptal Et",
    "new_apple_deleteaccount_stepsub_later" : "Daha Sonra",
    "new_apple_deleteaccount_stepsub_now" : "Şimdi",
    "new_apple_deleteaccount_title" : "Hesabın silinmesini talep et",
    "new_apple_deleteaccount_step1_1" : "Lütfen aşağıdaki hüküm ve koşulları dikkatlice okuyun:",
    "new_apple_deleteaccount_step1_2" : "Hesabınız  <span class=\"highlight\">kalıcı olarak</span> silinecektir. Hesabınızı oyuna giriş yapmak için kullanamayacaksınız. Hesap bilgileri geri alınamaz.",
    "new_apple_deleteaccount_step1_3" : "Sosyal medya hesabının hesapla bağlantısını kaldırmak istiyorsanız, hesabınızı silmeden önce lütfen bağlantı kaldırma işlemi için müşteri hizmetleri ekibiyle iletişime geçin. Aksi takdirde, hesabınızın başarılı bir şekilde silinmesinin ardından, oyuna giriş yapmak için bağlı sosyal medya hesabınızı kullanamazsınız. Lütfen hesabınızın silinmesi için başvurmadan önce oyundaki sanal varlıklarınızı uygun şekilde elden çıkardığınızdan emin olun.",
    "new_apple_deleteaccount_step1_4" : " <span class=\"highlight\">Geri ödeme için başvurmak istiyorsanız, lütfen hesabınızı silmeden önce geri ödeme için başvurun. </span>Lütfen hesabınızı silmeden önce sanal varlıklarınızı uygun şekilde elden çıkardığınızdan emin olun.",
    "new_apple_deleteaccount_step2_1" : "Oyundaki sanal varlıklarınızı uygun şekilde elden çıkardınız mı? Henüz yapmadıysanız, bir hesap silme talebi göndermeden önce lütfen konu için müşteri hizmetleri ekibiyle iletişime geçin.",
    "new_apple_deleteaccount_step2_2" : "Silme işlemini tamamlamak için lütfen \"Delete\" yazın. Hesap silme işlemi gerçekleştirildikten sonra iptal edilemez.",
    "new_apple_deleteaccount_step2_3" : "Silme işlemini tamamlamak için lütfen \"Delete\" yazın",
    "new_apple_deleteaccount_step3_1" : "Hesap silme talebiniz gönderildi. Aşağıdaki hesap silinmiştir:",
    "new_apple_deleteaccount_step3_2" : "Oyuna tekrar giriş yapmak istiyorsanız lütfen yeni bir hesap oluşturun.",
    "new_apple_deleteaccount_step4_1" : "Eski hesabınızı sildiniz. Lütfen bir dahaki sefere yeni bir hesapla giriş yapın.",
    "currencyTypeName" : "Para Birimi",
    "has_select_product" : "Öğelerin:",
    "n_product" : "\${n}",
    "look_detail_product" : "Tümünü Görüntüle",
    "limit_buy_product" : "Bu öğenin satın alma limiti: \${n}",
    "limit_order" : "Her seferinde en fazla \${n} öğe alabilirsin.",
    "limit_order_remove_tip" : "Bu sepetteki bazı ürünler için satın alma limitine ulaştın. Onları kaldırmak istiyor musun?",
    "paytype_limit" : "Bu ödeme yöntemi, bazı öğeleri satın almak için kullanılamaz. Lütfen farklı bir ödeme yöntemi seç veya bunları ayrı olarak satın almayı dene.",
    "check_remove_cart" : "Vagondan kaldır?",
    "remove_cart" : "Kaldır",
    "confirm_product" : "Onayla",
    "select_paytype" : "Ödeme Yöntemi Seç",
    "cart_is_empty_tip" : "Öğe bulunamadı. Lütfen önce bir öğe seç.",
    "thirty_tip" : "Satın aldığın öğeler 30 dakika içinde gelmezse, lütfen müşteri desteğimizle iletişime geç.",
    "total_n_product" : "Öğe x\${n}",
    "look_detail_of_cart" : "Tümünü Görüntüle",
    "order_detail" : "Öğe Listesi",
    "total_detail" : "Miktar:",
    "add_to_cart" : "Vagona ekle",
    "back_to_select" : "Geri",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Onayla",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "İnternet Sitesini \nZiyaret Et",
    "visitorLogin" : "Misafir",
    "tokenLogin" : "OTP",
    "fbLogin" : "Facebook ile giriş yap",
    "googleLogin" : "Google ile giriş yap",
    "twitterLogin" : "Twitter ile giriş yap",
    "vkLogin" : "VK ile giriş yap",
    "agreementTextStart" : "Oyuna giriş yaparak, şunları okuduğunuzu ve kabul ettiğinizi onaylamış olursunuz; Hizmet Şartları ve Gizlilik Politikası.",
    "userCenter" : "Kullanıcı Merkezi",
    "welcomeBack" : "Yeniden Hoş Geldiniz",
    "continueGame" : "BAŞLA",
    "officialPay" : "Yükleme Merkezi",
    "changeAccount" : "Hesap Değiştir",
    "back" : "Geri",
    "tokenKey" : "OTP",
    "inputUid" : "UID\'nizi girin",
    "inputToken" : "OTP\'nizi girin",
    "inputCkCode" : "Metni yazın",
    "enterGame" : "BAŞLA",
    "tokenTip" : "OTP Doğrulaması ile Hesabınızı Koruyun",
    "howToGetToken" : "Tek kullanımlık şifremi nasıl alabilirim?",
    "getStep1" : "Adım 1: Ayarlar > Hesap > Kullanıcı Merkezi",
    "getStep2" : "Adım 2: OTP’ye dokunun",
    "getStep3" : "Adım 3: UID ve tek kullanımlık şifrenizi kopyalayıp girin",
    "copy" : "Kopyala",
    "lastRefresh" : "Yenilenme:",
    "second" : "sn",
    "immediatelyRefresh" : "Şimdi Yenile",
    "frequently" : "İşlem çok sık. Lütfen daha sonra tekrar deneyin.",
    "loginFail" : "Giriş başarısız. Yanlış parola.",
    "tokenIntro" : "Tek Kullanımlık Şifre (OTP) Hakkında",
    "tokenIntro1" : "1. Tek kullanımlık şifrelerin 120 saniyelik geçerliliği vardır. Hesabınızı güvende tutmak için bunları akıllıca kullanın.",
    "tokenIntro2" : "2. Personelleri tek-kullanımlık şifrenizi istemez. Lütfen şifrenizi asla paylaşmayın veya vermeyin.",
    "nextStep1" : "Onayla",
    "couponCanUse" : "Kullanılabilir",
    "couponCanNotUse" : "Kullanılamaz",
    "couponHasNoCoupon" : "Kupon yok",
    "couponUseTip" : "Her sipariş için bir kupon kullan",
    "couponValidTime" : "Geçerlilik",
    "couponFuilCanUse" : "\${price} \${currency}  üzeri siparişler için kullanılabilir",
    "couponNoLimit" : "Sınır yok",
    "couponAllProductCanUse" : "Tüm eşyalar",
    "couponPartProductCanUse" : "Berlili eşyalar",
    "couponPartPaytypeCanUse" : "Belirli ödeme kanalları",
    "couponOnlyCoinCanUse" : "Yalnızca oyun-içi para birimi için",
    "couponOnlyDiamondCanUse" : "Yalnızca elmas için",
    "couponOnlyPackageCanUse" : "Yalnızca paketler için",
    "couponOnlySubCanUse" : "Yalnızca aboneler için",
    "couponOnlyDaibiCanUse" : "Yalnız jetonlar için",
    "couponMaxDiscount" : "\${price} \${currency} \'e varan indirim",
    "couponHasUsed" : "Kullanılan",
    "couponReductionType" : "Kesinti",
    "couponDiscountType" : "İndirim",
    "couponUseNow" : "Kullan",
    "couponHasNoSelect" : "Kupon kullanılmıyor",
    "couponHasSelectQuan" : "İndirimli",
    "couponSubmitTip" : "Kupon kullanılacak",
    "couponCanUseQuan" : "Kuponlar",
    "couponOrderTotal" : "Toplam",
    "couponHasDiscount" : "İndirim",
    "couponPayTotal" : "Ödeme",
    "couponCancel" : "İptal Et",
    "couponConfirm" : "Onayla",
    "uidLoginName" : "OTP ile giriş yap",
    "uidToken" : "OTP",
    "uidInputUid" : "UID\'nizi girin",
    "uidInputToken" : "OTP\'nizi girin",
    "uidInputCode" : "Metni yazın",
    "uidTipTitle" : "OTP Doğrulaması ile Hesabınızı Koruyun",
    "uidTipHowToGet" : "Tek kullanımlık şifremi nasıl alabilirim?",
    "uidTipStep1" : "Adım 1: Ayarlar > Hesap > Kullanıcı Merkezi",
    "uidTipStep2" : "Adım 2: OTP’ye dokunun",
    "uidTipstep3" : "Adım 3: UID ve tek kullanımlık şifrenizi kopyalayıp girin",
    "uidTipIntro1" : "1. Tek kullanımlık şifrelerin 60 saniyelik geçerliliği vardır. Hesabınızı güvende tutmak için bunları akıllıca kullanın.",
    "uidTipIntro2" : "2. Personelleri tek-kullanımlık şifrenizi istemez. Lütfen şifrenizi asla paylaşmayın veya vermeyin.",
    "couponMyQuan" : "Kuponlar",
    "couponSelectPaytypeTip" : "İndirim bilgilerini görmek için ödeme kanalını seç",
    "couponSelectCouponTip" : "İndirimli fiyatı görmek için kupon seç",
    "couponValidQuanTip" : "(Kupon x\${num} kullanılabilir)",
    "couponLookCart" : "Sepet",
    "couponUnfoldCart" : "Sakla",
    "couponCoupon" : "Kupon",
    "couponNoUse" : "Kullanılmıyor",
    "couponSelect" : "Kupon Seç",
    "couponSureUse" : "Kullan",
    "couponReturn" : "Geri",
    "couponInvalidTime" : "Süresi biter",
    "couponBuyNow" : "Şimdi Al",
    "couponAllType" : "all",
    "ztmslgType1" : "Günlük İndirim",
    "ztmslgType2" : "Kahraman",
    "ztmslgType3" : "Savaş Teçhizatı",
    "ztmslgType4" : "",
    "ztmslgType5" : "Çip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Kaynak",
    "ztmslgType8" : "İnşa Hızlandırma",
    "ztmslgType9" : "Nadir Öğeler",
    "ztmslgType10" : "İttifak",
    "ztmslgType11" : "Elmas",
    "ztmslgType12" : "Modül",
    "ztmslgType13" : "Küp",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nano Silah",
    "ztmslgType16" : "Büyük Ödül",
    "ztmslgType17" : "Çekirdek",
    "ztmslgType9999" : "Sınırlı Teklif",
    "ztmslgType10000" : "Hediye Merkezi",
    "ztmslgType10001" : "Tatil Etkinlikleri",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Günlük Satış",
    "antslgType2" : "Özelleşmiş Karınca",
    "antslgType3" : "Teçhizat",
    "antslgType5" : "Gen",
    "antslgType6" : "Salyangoz",
    "antslgType7" : "Kaynaklar",
    "antslgType8" : "Yapı & Araştırma",
    "antslgType9" : "Nadir Eşyalar",
    "antslgType10" : "İttifak",
    "antslgType11" : "Elmas",
    "antslgType12" : "Hücre",
    "antslgType13" : "Totem",
    "antslgType9999" : "Sınırlı Teklif",
    "antslgTypeother" : "other",
    "typeall" : "Tüm Ürünler",
    "vipHead" : "VIP Puanları",
    "vipHead213": "Ayrıcalıklı Üyelik",
    "vipTitle" : "VIP Puanı Etkinliği",
    "nowLevel" : "Seviyen:",
    "myVipScore" : "Puanların:",
    "nextLevelNeed" : "((VIP \${level} almak için \${num} puan kazan)",
    "ruleTitle" : "Kurallar:",
    "ztmslgVipRule1" : "1. Etkinlik 00:00 (UTC) 2022/09/22\'de başlar",
    "ztmslgVipRule2" : "2. Mevcut oyunlar:  Puzzles & Survival",
    "ztmslgVipRule3" : "Her tür etkinlik ödülü yalnızca bir kez alınabilir.",
    "ztmslgVipRule4" : "3. Giriş Kuponu etkinliği: Yükleme sayfasına ilk kez giriş yaptığında, %15 indirim sunan bir kupon talep edebileceksin.",
    "ztmslgVipRule5" : "4. VIP Puanları etkinliği: Puan kazanmak ve seviye kuponları ile haftalık kuponlar almak için resmi sayfamız üzerinden öğe satın al.",
    "ztmslgVipRule6" : "5. Kazanabileceğin puanlar kullandığın para birimine göre değişiklik gösterebilir. Daha fazla ayrıntı için lütfen alttaki bağlantıyı kontrol et.",
    "ztmslgVipRule7" : "6. Kupon kullanırken, kuponlar düşüldükten sonra ödediğin tutara göre puan kazanırsın.",
    "ztmslgVipRule8" : "7. Kazandığın puanların süresi 365 gün içinde sona erecek. Bu VIP seviyeni etkileyebilir.",
    "ztmslgVipRule9" : "8. İlk kez bir VIP seviyesine ulaştığın için hemen bir kupon alacaksın. Haftalık kupon her Cumartesi 00:00\'da (UTC+0) alınabilir.",
    "ztmslgVipRule10" : "9. Haftalık kuponu talep etmek için giriş yapman gerekecek. Kaçırma!",
    "ztmslgVipRule11" : "10. Kuponun para birimi, son siparişinin para biriminden olacak. Kullanmakta olduğun para birimini değiştirmek istersen lütfen müşteri hizmetlerimizle iletişime geç.",
    "ztmslgVipRule12" : "11. VIP seviyeleri ve kuponlar hakkında daha fazla ayrıntı için aşağıdaki tabloya bak.",
    "ztmslgVipRule13" : "12. Herhangi bir anlaşmazlık durumunda, Puzzles & Survival destek ekibi bu Hüküm ve Koşulların yorumlanması konusunda yegane ve nihai takdir yetkisine sahiptir.",
    "vipLevel" : "VIP Seviyesi",
    "vipCondition" : "Gerekli puanlar",
    "firstSend" : "İlk ulaşan ödül",
    "weeklySend" : "Haftalık kupon",
    "lastAllCoupon" : "Önceki kademe kuponları",
    "besides" : "Para Birimi/Puan Tablosu:",
    "couponRatio" : "Para Birimi/Puan Oranı:",
    "backToPay" : "GERİ",
    "quanGift" : "KUPON",
    "quanGiftTips" : "Talep edilebilir kuponların var)!",
    "antslgVipRule1" : "Bir özellik güncellemesi nedeniyle, \"VIP Puanları\" etkinliği yakında durdurulacaktır.",
    "antslgVipRule2" : "VIP Puanları etkinliğinden elde edilen kuponları, geçerlilik süreleri dolmadan önce kullanmayı unutmayın.",
    "antslgVipRule3" : "Bitiş Zamanı: 28/09/2024 00.00.00 (UTC)",
    "antslgVipRule4" : "Etkinlik sona erdikten sonra, daha fazla avantajdan yararlanmak için Ayrıcalıklı Üyelik Merkezi'ni ziyaret edebilirsiniz:",
    "antslgVipRule5" : "Kuponlar, oyun içi öğeler ve diğer ödüllerle takas edilebilen puanlar kazanmak için görevleri tamamlayın! Özel üye avantajlarının ve şanslı çekilişlerin tadını çıkarın.",
    "antslgVipRule6" : "Daha fazla ödül ve etkinlik için takipte kalın!",
    "dzgVipRule0" : "1. Etkinlik 00:00 (UTC) 2022/09/27\'de başlar",
    "dzgVipRule1" : "1. Mevcut oyunlar: \${gameName}",
    "dzgVipRule2" : "Her tür etkinlik ödülü yalnızca bir kez alınabilir.",
    "dzgVipRule3" : "2. Giriş Kuponu etkinliği: Yükleme sayfasına ilk kez giriş yaptığında, %15 indirim sunan bir kupon talep edebileceksin.",
    "dzgVipRule4" : "3. VIP Puanları etkinliği: Puan kazanmak ve seviye kuponları ile haftalık kuponlar almak için resmi sayfamız üzerinden öğe satın al.",
    "dzgVipRule5" : "4. Kazanabileceğin puanlar kullandığın para birimine göre değişiklik gösterebilir. Daha fazla ayrıntı için lütfen alttaki bağlantıyı kontrol et.",
    "dzgVipRule6" : "5. Kupon kullanırken, kuponlar düşüldükten sonra ödediğin tutara göre puan kazanırsın.",
    "dzgVipRule7" : "6. Kazandığın puanların süresi 365 gün içinde sona erecek. Bu VIP seviyeni etkileyebilir.",
    "dzgVipRule8" : "7. İlk kez bir VIP seviyesine ulaştığın için hemen bir kupon alacaksın. Haftalık kupon her Cumartesi 00:00\'da (UTC+0) alınabilir.",
    "dzgVipRule9" : "8. Haftalık kuponu talep etmek için giriş yapman gerekecek. Kaçırma!",
    "dzgVipRule10" : "9. Kuponun para birimi, son siparişinin para biriminden olacak. Kullanmakta olduğun para birimini değiştirmek istersen lütfen müşteri hizmetlerimizle iletişime geç.",
    "dzgVipRule11" : "10. VIP seviyeleri ve kuponlar hakkında daha fazla ayrıntı için aşağıdaki tabloya bak.",
    "dzgVipRule12" : "11. Herhangi bir anlaşmazlık durumunda, \${gameName} destek ekibi bu Hüküm ve Koşulların yorumlanması konusunda yegane ve nihai takdir yetkisine sahiptir.",
    "213dzgVipRule1" : "Bir özellik güncellemesi nedeniyle, \"VIP Puanları\" etkinliği yakında durdurulacaktır.",
    "213dzgVipRule2" : "VIP Puanları etkinliğinden elde edilen kuponları, geçerlilik süreleri dolmadan önce kullanmayı unutmayın.",
    "213dzgVipRule3" : "Bitiş Zamanı: 19/08/2024 08.00.00 (UTC)",
    "213dzgVipRule4" : "Etkinlik sona erdikten sonra, daha fazla avantajdan yararlanmak için Ayrıcalıklı Üyelik Merkezi'ni ziyaret edebilirsiniz:",
    "213dzgVipRule5" : "Kuponlar, oyun içi öğeler ve diğer ödüllerle takas edilebilen puanlar kazanmak için görevleri tamamlayın! Özel üye avantajlarının ve şanslı çekilişlerin tadını çıkarın.",
    "213dzgVipRule6" : "Daha fazla ödül ve etkinlik için takipte kalın!",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Hesabı Bağla/Kaldır",
    "unbindApply" : "Kaldır",
    "unbindConfirmTitle" : "Hesabı kaldırmak istediğine emin misin?",
    "unbindConfirmTip" : "Hesabı kaldırmak, oyun kaydı/ilerleme kaybına neden olabilir.",
    "unbindConfirm" : "Yine de kaldır",
    "unbindExit" : "Çık",
    "unbindSucc" : "Hesap kaldırıldı",
    "unbindFail" : "Hesabının bağlantısı kaldırılamadı. Lütfen müşteri hizmetleriyle iletişime geç.",
    "unbindServiceTitle" : "Lütfen manuel kaldırmaya başvur",
    "unbindContact" : "Müşteri Hizmetleri",
    "unbindServiceTip" : "Hesabının bağlantısını kaldıramazsın. Lütfen müşteri hizmetleriyle iletişime geç.",
    "antslgType15" : "Kalıtım",
    "shareEventTitle" : "Arkadaşlarını Davet</br>Et\nÖdülleri Kazan",
    "shareRule" : "Kurallar",
    "awardBag" : "Ödülüm",
    "initiatorText" : "Ben bir Davetçiyim",
    "inviteeText" : "Ben bir Davetliyim",
    "createCode" : "Davet Kodu Oluştur",
    "createCodeTip" : "Davet kodu oluşturmak için dokun",
    "createLinkTip" : "Davet linki oluşturmak için dokun",
    "copyText" : "Kopyala",
    "shareCode" : "Davet Kodu Paylaş",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Ödülü Görüntüle",
    "seeAwardTip" : "Lütfen ödüllerini <span class=\"see-light\">VIP Noktası</span> > <span class=\"see-light\">Kuponum bölümünden </span>kontrol et.",
    "inviteReward" : "Davet Özeti",
    "inviteRewardTip" : "Davet eden kişi bu ödülleri ancak her bir davetli bu hedeflere ilk kez ulaştığında talep edebilir.",
    "overweightReward" : "Bonus Ödülü",
    "resetTip" : "Her ayın son günü 00:00\'da sıfırlanır.",
    "rewardText1" : "Davetli Toplam Yükleme: \$9.99",
    "rewardText2" : "Davetli Toplam Yükleme: \$49.99",
    "rewardText3" : "Davetli Toplam Yükleme: \$99.99",
    "rewardText4" : "Davet Edilen Her 5 Oyuncu İçin 1x %12 İndirim Kuponu Kazan",
    "rewardText5" : "Davetlilerin Toplam \$1.000 Yükledikten Sonra 1x %15 İndirim Kuponu kazan",
    "invitationList" : "Davetim",
    "refresh" : "Yenile",
    "invitedTotal" : "Davet edildi: \${total}",
    "storedTotal" : "Total Yükleme: \${total} USD",
    "people" : "",
    "invitedPeople" : "Davetli",
    "invitedTime" : "Davet edildi",
    "got" : "Başarıldı",
    "get" : "Tamamlanmadı",
    "overlay" : "İstiflenebilir",
    "couponText" : "Kupon",
    "personalReward" : "Yükleme Ödülü",
    "personalRewardText1" : "Total Yükleme \$9.99 oldu",
    "personalRewardText2" : "Total Yükleme \$49.99 oldu",
    "personalRewardText3" : "Total Yükleme \$99.99 oldu",
    "inputCode" : "Davet Kodunu Gir",
    "bindCode" : "Onayla",
    "bindSucc" : "Bağlı",
    "codeTip1" : "Kod mevcut değil.",
    "codeTip2" : "Davet Kodu Bağlı",
    "copySucc" : "Başarılı!",
    "awardName" : "Ödül",
    "getTime" : "Alındı",
    "getCondition" : "Koşul",
    "couponText1" : "%6 İndirim Kuponu",
    "couponText2" : "%8 İndirim Kuponu",
    "couponText3" : "%10 İndirim Kuponu",
    "couponText4" : "%12 İndirim Kuponu",
    "couponText5" : "%15 İndirim Kuponu",
    "ruleText1" : "1. Etkinlik başlangıç saati: 25/11/2022, 00:00 UTC",
    "ruleText2" : "2. Etkinlik oyunu: Puzzles & Survival",
    "ruleText3" : "3. \"Resmi Yükleme Site Paylaşımı\" etkinliği: Bu resmi yükleme sitesini arkadaşlarınla paylaş ve onları yüklemeye davet et. Bu sayfa üzerinden belirli bir miktar yüklerlerse, ödüllendirileceksin.",
    "ruleText4" : "4. Üçüncü taraf ödemesinden gelen Aylık Ödüller: Ödüller kazanmak için aylık paylaşım hedeflerine ulaş. Ödülleri paylaşma her ay sıfırlanır.",
    "ruleText5" : "5. Aylık Ödüller, davet ettiğin yeni oyuncular tarafından üçüncü tarafça sitede en az bir başarılı yükleme ödemesi gerektirir.",
    "ruleText6" : "6. Aylık Ödüller, her ayın ilk gününde sıfırlanır. Bu aynı zamanda önceki aya ait ilerlemeleri de sıfırlar.",
    "ruleText7" : "7. Ödüllü kupon, üçüncü taraf yükleme sitesine giriş yapılarak talep edilmelidir. Süresi dolmuşsa başka bir kupon almayacaksın.",
    "ruleText8" : "8. Kupon, önceki başarılı yüklemelerde kullandığın para birimini kullanır.",
    "ruleText9" : "9. Seninki zaten kullanılmışsa, başka bir oyuncunun davet kodunu kullanamazsın.",
    "ruleTableTitle1" : "Kurallar：",
    "ruleTableTitle2" : "VIP Katmanları ve Açıklanan Kuponlar:",
    "ruleTableHead1" : "Yükleme Gereksinimi",
    "ruleTableHead2" : "Ödül Gereksinimi",
    "ruleTableHead3" : "Ödüller",
    "ruleTableContent1" : "5 yeni oyuncu davet et",
    "ruleTableContent2" : "Davet edilen oyuncular \$1,000 USD yükleme yaptı",
    "errorTip" : "İşlem başarısız",
    "eventShareText1" : "Puzzles & Survival Sınırlı Süreli Teklifler",
    "eventShareText2" : "Bir Sürü Hediye Seni Bekliyor!",
    "cartDoubleTip" : "Kutu Çoğaltıcılar desteklenmiyor.",
    "codeTip3" : "Giriş yapılmadı",
    "codeTip4" : "Parametre eksik",
    "codeTip5" : "Kendi davet kodunu bağlayamazsın",
    "codeTip6" : "Davet Kodu Oluşturuldu",
    "payWelfare" : "Yükleme Festivali",
    "wallet" : "Cüzdan",
    "myDiscount" : "Kuponum",
    "knowMore" : "Dahası",
    "backPay" : "Geri",
    "curBalance" : "Bakiye",
    "pay" : "Yükleme",
    "changeCoin" : "Para Birimini Değiştir",
    "watchDesc" : "Detayları Gör",
    "getMore" : "Daha Fazla Al",
    "getDiscount" : "Kuponlarını Al",
    "notOpenDiscountQuan" : "Etkinlik yok. Beklemede kal!",
    "abountZbit" : "\${Z-BIT} Hakkında",
    "remain" : "Kalan:",
    "payRemain" : "Satın aldıktan sonra kalan miktar:",
    "payRemainExpiry" : "Ödeme sonrası tahmini kalan ${money} (1 Ocak 2026'da sona erecek, lütfen en kısa sürede kullanın)",
    "balanceNotEnoughExpiry" : "Yetersiz bakiye (1 Ocak 2026'da sona erecek, yükleme yapılamaz)",
    "balanceNotEnoggh" : "Yeterli bakiye yok. Lütfen önce yükle.",
    "goToPay" : "Yükleme",
    "chooseOtherPay" : "Diğer Ödeme Yöntemi",
    "payIntro" : "Yükleme Detayları",
    "logRole" : "Karakter Seç",
    "chooseProduct" : "Öğe Seç",
    "meAgree" : "Şartları okudum ve kabul ediyorum.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "\${Z-BIT} kullanılmadan önce dinamik doğrulama gereklidir",
    "dl3dvnVipRule1" : "1. Mevcut oyunlar: \${gameName}",
    "dl3dvnVipRule2" : "Her tür etkinlik ödülü yalnızca bir kez alınabilir.",
    "dl3dvnVipRule3" : "2. Giriş Kuponu etkinliği: Yükleme sayfasına ilk kez giriş yaptığında, %15 indirim sunan bir kupon talep edebileceksin.",
    "dl3dvnVipRule4" : "3. VIP Puanları etkinliği: Puan kazanmak ve seviye kuponları ile haftalık kuponlar almak için resmi sayfamız üzerinden öğe satın al.",
    "dl3dvnVipRule5" : "4. Kazanabileceğin puanlar kullandığın para birimine göre değişiklik gösterebilir. Daha fazla ayrıntı için lütfen alttaki bağlantıyı kontrol et.",
    "dl3dvnVipRule6" : "5. Kupon kullanırken, kuponlar düşüldükten sonra ödediğin tutara göre puan kazanırsın.",
    "dl3dvnVipRule7" : "6. Kazandığın puanların süresi 365 gün içinde sona erecek. Bu VIP seviyeni etkileyebilir.",
    "dl3dvnVipRule8" : "7. İlk kez bir VIP seviyesine ulaştığın için hemen bir kupon alacaksın. Haftalık kupon her Cumartesi 00:00\'da (UTC+0) alınabilir.",
    "dl3dvnVipRule9" : "8. Haftalık kuponu talep etmek için giriş yapman gerekecek. Kaçırma!",
    "dl3dvnVipRule10" : "9. Kuponun para birimi, son siparişinin para biriminden olacak. Kullanmakta olduğun para birimini değiştirmek istersen lütfen müşteri hizmetlerimizle iletişime geç.",
    "dl3dvnVipRule11" : "10. VIP seviyeleri ve kuponlar hakkında daha fazla ayrıntı için aşağıdaki tabloya bak.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. Herhangi bir anlaşmazlık durumunda, \${gameName} destek ekibi bu Hüküm ve Koşulların yorumlanması konusunda yegane ve nihai takdir yetkisine sahiptir.",
    "codeTip7" : "Seninkini zaten kullandıkları için hedef oyuncunun kodunu kullanamazsın",
    "ruleText10" : "10. Puzzles & Survival resmi yönetimi, nihai yorumlama için tüm haklarını saklı tutar.",
    "payCoins" : "Yükleme VIP Noktası",
    "shareGift" : "Hediyeler için paylaş",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "Seçilen bölgede geçerli ödeme yöntemi yok. Lütfen bölgeyi değiştir ve tekrar dene.",
    "dl3dtwVipRule1" : "1. Mevcut oyunlar: \${gameName}",
    "dl3dtwVipRule2" : "Her tür etkinlik ödülü yalnızca bir kez alınabilir.",
    "dl3dtwVipRule3" : "2. VIP Puanları etkinliği: Puan kazanmak ve seviye kuponları ile haftalık kuponlar almak için resmi sayfamız üzerinden öğe satın al.",
    "dl3dtwVipRule4" : "3. Kazanabileceğin puanlar kullandığın para birimine göre değişiklik gösterebilir. Daha fazla ayrıntı için lütfen alttaki bağlantıyı kontrol et.",
    "dl3dtwVipRule5" : "4. Kupon kullanırken, kuponlar düşüldükten sonra ödediğin tutara göre puan kazanırsın.",
    "dl3dtwVipRule6" : "5. Kazandığın puanların süresi 365 gün içinde sona erecek. Bu VIP seviyeni etkileyebilir.",
    "dl3dtwVipRule7" : "6. İlk kez bir VIP seviyesine ulaştığın için hemen bir kupon alacaksın. Haftalık kupon her Cumartesi 00:00\'da (UTC+0) alınabilir.",
    "dl3dtwVipRule8" : "7. Haftalık kuponu talep etmek için giriş yapman gerekecek. Kaçırma!",
    "dl3dtwVipRule9" : "8. Kuponun para birimi, son siparişinin para biriminden olacak. Kullanmakta olduğun para birimini değiştirmek istersen lütfen müşteri hizmetlerimizle iletişime geç.",
    "dl3dtwVipRule10" : "9. VIP seviyeleri ve kuponlar hakkında daha fazla ayrıntı için aşağıdaki tabloya bak.",
    "dl3dtwVipRule11" : "10. Herhangi bir anlaşmazlık durumunda, \${gameName} destek ekibi bu Hüküm ve Koşulların yorumlanması konusunda yegane ve nihai takdir yetkisine sahiptir.",
    "eventInviteSucc" : "Bir Arkadaşını Davet Et",
    "eventGainCondition" : "Şartlar",
    "eventSuccInvite" : "Bir Arkadaşını Davet Et",
    "eventInviteGainOne" : "Davetli Toplam \nYükleme: \$49.99",
    "eventInviteGainTwo" : "Davetli Toplam \nYükleme: \$99.99",
    "eventFriendCode" : "Arkadaşının kodu:",
    "eventCheckBind" : "Bağla?",
    "eventConfirm" : "Onayla",
    "eventCancel" : "İptal Et",
    "eventBindSucc" : "Bağlama başarılı!",
    "eventGainCoupon" : "Bir kupon aldın.",
    "eventLookCoupon" : "Kuponu Görüntüle",
    "eventSuccBind" : "Bağlama başarılı",
    "recaptchaTip" : "Lütfen önce doğrula",
    "inputAccountName" : "Lütfen kurtarmak istediğin hesabı gir",
    "pwaPayTip" : "Hızlı Erişim, Daha İyi Deneyim",
    "pwsInstall" : "Ana Ekrana ekle",
    "ztmslgType999" : "Kupon",
    "coinUseTips" : "Satın alımla, Kuponlar oyun posta kutuna gönderilecek. Kuponlar, oyundaki Kupon Mağazasından öğeler satın almak için kullanılabilir. Öğe satın almak için kullanılan kuponlar toplam yüklemene sayılacak.",
    "notice" : "Duyuru",
    "popupConfirm" : "Onayla",
    "hideWithinWeek" : "7 gün boyunca bir daha gösterme",
    "ztmslgProductOffTips" : "13 Mart\'ta uygulanması planlanan ödeme sayfasındaki değişiklikler hakkında çok fazla geri bildirim aldık. Buna yanıt olarak, bu değişiklikleri iptal etmeye karar verdik ve alışveriş deneyiminizi geliştirmeye odaklanacağız. Görüşleriniz için minnettarız, anlayışınız ve desteğiniz için teşekkür ederiz. Başka sorunuz varsa, lütfen Müşteri Desteği ekibimizle iletişime geçin.",
    "couponTopLimit" : "Para Birimiyle Kesilebilecek Maksimum Tutarlar",
    "swsjpVipRule1" : "1. Etkinlik 00:00 (UTC) 2023/03/24\'de başlar",
    "swsjpVipRule2" : "2. Mevcut oyunlar: \${gameName}",
    "swsjpVipRule3" : "Her tür etkinlik ödülü yalnızca bir kez alınabilir.",
    "swsjpVipRule4" : "3. Giriş Kuponu etkinliği: Yükleme sayfasına ilk kez giriş yaptığında, %15 indirim sunan bir kupon talep edebileceksin.",
    "swsjpVipRule5" : "4. VIP Puanları etkinliği: Puan kazanmak ve seviye kuponları ile haftalık kuponlar almak için resmi sayfamız üzerinden öğe satın al.",
    "swsjpVipRule6" : "5. Kazanabileceğin puanlar kullandığın para birimine göre değişiklik gösterebilir. Daha fazla ayrıntı için lütfen alttaki bağlantıyı kontrol et.",
    "swsjpVipRule7" : "6. Kupon kullanırken, kuponlar düşüldükten sonra ödediğin tutara göre puan kazanırsın.",
    "swsjpVipRule8" : "7. Daha önceki satın alımlar için zaten puan kazandın.",
    "swsjpVipRule9" : "8. Kazandığın puanların süresi 365 gün içinde sona erecek. Bu VIP seviyeni etkileyebilir.",
    "swsjpVipRule10" : "9. İlk kez bir VIP seviyesine ulaştığın için hemen bir kupon alacaksın. Haftalık kupon her Cumartesi 00:00\'da (UTC+0) alınabilir.",
    "swsjpVipRule11" : "10. Haftalık kuponu talep etmek için giriş yapman gerekecek. Kaçırma!",
    "swsjpVipRule12" : "11. Kuponun para birimi, son siparişinin para biriminden olacak. Kullanmakta olduğun para birimini değiştirmek istersen lütfen müşteri hizmetlerimizle iletişime geç.",
    "swsjpVipRule13" : "12. Herhangi bir anlaşmazlık durumunda, \${gameName} destek ekibi bu Hüküm ve Koşulların yorumlanması konusunda yegane ve nihai takdir yetkisine sahiptir.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Kupon",
    "passAskMods" : "Moderatöre Sor",
    "passAskModsTip" : "Moderatörlere oyunla ilgili her türlü soruyu sor",
    "passService" : "Müşteri Sorgusu",
    "passServiceTip" : "Hesap ve yükleme ile ilgili soruların için lütfen müşteri hizmetlerimizle iletişime geç.",
    "passIKonw" : "OK",
    "passGoOn" : "Devam Et",
    "voucherTitle" : "Resmi Yükleme Merkezi",
    "voucherAddHome" : "Masaüstüne Ekle",
    "voucherAddHomeTipOne" : "Daha Hızlı Ödeme, Daha İyi Deneyim",
    "voucherAddHomeTipTwo" : "Araç çubuğunda [Paylaş]\'a dokun",
    "voucherAddHomeTipThree" : "[Masaüstüne Ekle]’yi Seç",
    "voucherLoginLook" : "Teklifleri görüntülemek için giriş yap",
    "voucherSwitchRole" : "Karakteri Değiştir",
    "voucherCoupon" : "Kupon",
    "voucherVip" : "VIP Puanı",
    "voucherMoreCoupon" : "Daha Fazla Teklif",
    "voucherAccountId" : "Hesap ID",
    "voucherOtp" : "TKŞ",
    "voucherOtherWayPay" : "Başka ödeme yöntemi seç",
    "voucherOtherLoginWay" : "Başka bir yöntem dene",
    "voucherCouponActivity" : "İndirimli Satışlar",
    "voucherActivityNotBegin" : "Etkinlik henüz başlamadı.",
    "voucherGoCommunity" : "Topluluktan yükleme avantajları hakkında daha fazla bilgi edin",
    "voucherValidTime" : "Geçerlilik",
    "voucherLimitRegion" : "Sadece \${currency} için",
    "voucherLiuyi" : "Kullanılabilir kupon yok. Lütfen ileriki etkinliklere dikkat et.",
    "voucherPay" : "Kupon Satın Al",
    "voucherAbout" : "Kupon Hakkında",
    "voucherChooseWay" : "Ödeme Yöntemi Seç",
    "voucherMoreWay" : "Daha Fazla Ödeme Yöntemi",
    "voucherChooseCoupon" : "Kupon Seç",
    "voucherHasChoose" : "Seçilen",
    "voucherMoneyInsufficient" : "Yetersiz bakiye",
    "voucherContact" : "Yetersiz bakiye. Lütfen destek ekibimizle iletişime geç.",
    "voucherCouponTotal" : "Mevcut Kuponlar",
    "voucherCouponTipGuide" : "Kuponlar, ödeme kanalını seçtikten sonra ödeme için kullanılabilir.",
    "voucherPaytypeNotSupport" : "Bu ödeme kanalı için kupon kullanılamıyor",
    "voucherTipSideOne" : "Kuponlar, kuponun kendisi hariç tüm oyun içi paketler ve katma değerli hizmetler için değiştirilebilir.",
    "voucherTipSideTwo" : "%15\'e varan indirim",
    "voucherYue" : "Bakiye",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Hayatta Kalma Kılavuzu",
    "vipHeadText" : "VIP özel çerçevenin kilidi açıldı",
    "vipHeadGetText" : "Talep Et",
    "vipHeadGotText" : "Talep edildi",
    "vipHeadGetTitle" : "Onayla",
    "vipHeadGetTip" : "Bu ödül hesap başına yalnızca bir kez talep edilebilir. Devam et?",
    "vipHeadAwardText" : "Elit Kumandan (Kalıcı)",
    "vipHeadGetErrTip1" : "Başarısız. Lütfen daha sonra tekrar dene veya MS ile iletişime geç.",
    "cartGuideTipNew" : "Kupon kullanmak için daha fazla öğe ekle",
    "newVipTitle" : "Yükleme Merkezi VIP",
    "newVipLogin" : "GİRİŞ YAP",
    "newVipNowPoint" : "Puanlar:",
    "newVipNextLevel" : "Bir sonraki seviyeye \${point} puan",
    "newVipUpgrade" : "YÜKSELT",
    "newVipLevel" : "VIP Ayrıcalıkları",
    "newVipTip" : "Kuponlar her Cumartesi 00:00\'da (UTC) yenilenecektir. Resmi yükleme sayfasında oturum açtığında bunları alacaksın.",
    "newVipWeekly" : "Haftalık Hediye",
    "newVipReachPoint" : "Gereksinimler:",
    "newVipRuleInfo" : "Kurallar:",
    "pleaseLang" : "Dil",
    "reference" : "Sipariş Numarası",
    "saveToNext" : "Kredi kartı bilgilerini kaydet.",
    "cardNum" : "Kart Numarası",
    "expireTime" : "Geçerlilik Süresi",
    "CVV" : "CVV",
    "pleaseCard" : "Kredi kartı türü",
    "howToPay" : "Nasıl ödeme yapmak istersin?",
    "checkCard" : "Lütfen kart numaranı kontrol et.",
    "checkExpiryDate" : "Lütfen kartının son kullanma tarihini kontrol et.",
    "checkCVV" : "Lütfen kartının CVV kodunu kontrol et.",
    "addCard" : "Yeni",
    "delete" : "Sil",
    "deleteCardTips" : "Kayıtlı kredi kartı bilgilerini sil.",
    "confirmDelete" : "Evet sil",
    "cancelDelete" : "İptal Et",
    "checkAllCardMsg" : "Lütfen kredi kartı numarasını, son kullanma tarihini ve CVV numarasını doğru girdiğinize emin olun.",
    "leaveCreditPageTips" : "La transazione non sarà completata se lasci questa pagina ora. Abbandonare comunque?",
    "sureToLeave" : "Abbandona",
    "continueToPay" : "Continua",
    "pushTest" : "Bildirim Testi",
    "getNoticication" : "Oyun bildirimleri almıyor musun?",
    "waitCheckResult" : "Lütfen test sonucunu bekle.",
    "hadAbnormal" : "Bildirim hatasına yol açabilecek bir anormallik bulundu.",
    "clickIntro" : "Çözümü görmek için rapora dokun",
    "networkCheck" : "Ağ testi",
    "noticeAuthorityCheck" : "Bildirim erişim testi",
    "noticeBtnCheck" : "Bildirim çubuğu testi",
    "gmsCheck" : "GMS hizmeti testi",
    "batteryCheck" : "Pil optimizasyon listesi testi",
    "pushServiceCheck" : "Bildirim hizmeti testi",
    "reCheck" : "Tekrar Test Et",
    "noNoticeAuthorityTip" : "Bu cihazda bildirim erişimi verilmemiş. Oyuna erişim izni vermek için Sistem Ayarları - Bildirimler bölümüne git.",
    "noNoticeBtnTip" : "Bildirim çubuğu kapalı. Lütfen Sistem Ayarlarından aç.",
    "noBatteryTip" : "Oyun pil optimizasyon listesinde, bildirimleri alamayabilirsin. Oyunu güvenli listeye eklemek için lütfen Sistem Ayarları - Pil - Pil Optimizasyonu bölümüne git.",
    "noPushServiceTip" : "Bildirim sunucusu bağlı değil. Hizmete devam etmek için [Bağlan] öğesine dokun.",
    "noNetworkTip" : "Mevcut ağ bağlantın stabil değil",
    "noGmsTip" : "Cihazın GMS\'yi desteklemiyor. GMS ile uyumlu bir cihaz kullan.",
    "pushConnectFail" : "Bildirim sunucusunun bağlantısı kesildi.",
    "pushConnectSucc" : "Bildirim sunucusuna bağlanıldı.",
    "noGetPushTitle" : "Eğer hala oyundan bildirim alamıyorsan lütfen aşağıdaki adımları uygula:",
    "noGetPushContOne" : "1. Oyundan çıkış yap ve ardından bu cihazda tekrar oturum aç.",
    "noGetPushContTwo" : "2. Mevcut kullanımdaki cihazının test bildirimini alıp alamadığını kontrol etmek için [Bildirim Testi] öğesine dokun.",
    "noGetPushContThree" : "3. Test bildirimini aldıysan ancak hala başka bir bildirim alamıyorsan, lütfen oyunda oturum aç, Ayarlar - Bildirimler\'e git ve tüm bildirimlerin açık olup olmadığını kontrol et.",
    "noGetPushContFour" : "4. Hala bildirim alamıyorsan, lütfen müşteri hizmetlerimizle iletişime geç.",
    "getPushSucc" : "Cihazın bir test bildirimi aldı. Normal çalışıyor!",
    "allCheckSucc" : "Bildirim testi yapıldı. Hiçbir anormallik bulunamadı!",
    "pushCheck" : "Bildirim testi",
    "useDirectPay" : "Hızlı Ödeme Kullan",
    "paypalFraudnetInfo" : "PayPal ile güvenli ödeme",
    "goToSetting" : "Ayarlar",
    "retry" : "Tekrar Dene",
    "connect" : "Bağlan",
    "canRebind" : "Bağlamayı kaldırdıktan sonra tekrar bağlayabilirsin",
    "agreePlatform" : "\${service} ve \${privite}\'yi kabul ediyorum.",
    "sendGameNews" : "Bültenlere abone ol.",
    "canNotBindEmail" : "Bağlantıyı kaldırdıktan sonra bu e-postayı oturum açmak için kullanamazsın.",
    "canNotBindPhone" : "Bağlantıyı kaldırdıktan sonra bu cep telefonu numarasını oturum açmak için kullanamazsın.",
    "canChangeByEmail" : "Farklı cihazlardan e-posta ile giriş yapabilirsin.",
    "canChangeByPhone" : "Farklı cihazlardan cep telefonu numarası ile giriş yapabilirsin.",
    "loginSucc" : "Giriş yapıldı",
    "phoneHadBind" : "Cep telefonu numarası zaten bağlı. Onunla giriş yap?",
    "emailHadBind" : "E-posta zaten bağlı. Onunla giriş yap?",
    "phoneNotBind" : "Cep telefonu numarası henüz bağlanmadı. Yeni bir hesap oluştur?",
    "emailNotBind" : "E-posta numarası henüz bağlanmadı. Yeni bir hesap oluştur?",
    "emailAccount" : "E-posta Hesabı",
    "phoneAccount" : "Cep Telefonu Hesabı",
    "phoneInputError" : "Geçersiz cep telefonu numarası",
    "registerNewAccount" : "Kayıt Ol",
    "secureTip" : "Hesap Güvenlik İpuçları",
    "toTop" : "Başa sabitleyin",
    "createNewWork" : "Yeni Destek Talebi",
    "serviceEvaluate" : "Hizmeti Değerlendir",
    "emailRemind" : "Bildirimler",
    "isAgreeService" : "Hizmetimizi nasıl buldunuz?",
    "thankEvaluateTop" : "Geri bildiriminiz için teşekkür ederiz!",
    "inputValidEmail" : "Lütfen geçerli bir e-posta adresi girin.",
    "replyWillRemind" : "Sorunuz yanıtlandığında bilgilendirici bir e-posta alacaksınız. Kapatmak için tekrar dokunun.",
    "isCancelEmailRemind" : "Herhangi bir bilgilendirme e-postası almayacaksınız. Yine de kapat?",
    "reconfirmEmail" : "Lütfen e-posta adresinizi onaylayın.",
    "confirmCanSubmit" : "Bileti göndermek için onaylayın",
    "serviceWillReply" : "Müşteri hizmetleri yanıt verdiğinde e-posta ile bilgilendirileceksiniz.",
    "cancelEmailRemind" : "[Bildirimleri] kapat?",
    "yes" : "Evet",
    "no" : "Hayır",
    "inputWorkSearch" : "Aranıyor...",
    "loading" : "Yükleniyor",
    "loadingError" : "Yükleme başarısız oldu. Lütfen tekrar yükleyin...",
    "noMore" : "Başka bir şey yok",
    "cancelToTop" : "Çöz",
    "evaluateOne" : "Çok kötü",
    "evaluateTwo" : "Kötü",
    "evaluateThree" : "Nötr",
    "evaluateFour" : "İyi",
    "evaluateFive" : "Çok iyi",
    "confirmDelWorkTop" : "bu destek talebini sil?",
    "reRemindEmail" : "E-posta bildirimine mi ihtiyacınız var? [Bildirimler] düğmesine tekrar dokunun.",
    "confirmWillReply" : "Müşteri hizmetleri yanıt verdiğinde e-posta ile bilgilendirilmeyi kabul ettiğinizi onaylayın.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Silinen bir destek talebi geri alınamaz.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Video yüklendi",
    "videoUploadFail" : "Video yüklenemedi",
    "videoUploadLimit" : "Lütfen boyutu 400 MB\'ın altında ve 2 dakikadan uzun olmayan bir mp4 dosyası yükleyin.",
    "imageUploadSucc" : "Resim yüklendi",
    "imageUploadFail" : "Resim yüklenemedi",
    "uploading" : "Yükleniyor",
    "smartOrderCreate" : "Hızlı Destek Kaydı",
    "smartOrderSearch" : "Arama",
    "smartOrderComing" : "Çok yakında",
    "smartOrderContactService" : "Müşteri Hizmetleri",
    "smartOrderDetector" : "Asistan",
    "smartOrderDetect" : "Tanıla",
    "smartOrderDetecting" : "Tanılanıyor",
    "smartOrderDetectTip" : "Oyunu oynarken bir sorun tespit edildi. Tespit edebilmemiz için lütfen Tanıla’ya dokunun.",
    "smartOrderDetectTip2" : "Sorun tespit edildi. Sizin için çözebilmemiz için bir destek talebi oluşturun!",
    "smartOrderSubmit" : "Gönder",
    "smartOrderIKnow" : "TAMAM",
    "smartOrderConfirm" : "TAMAM",
    "smartOrderLook" : "Görüntüle",
    "smartOrderIsHelp" : "Bu makale faydalı oldu mu?",
    "smartOrderInputQuestion" : "Karşılaştığınız sorunu yazın.",
    "smartOrderPleaseInpt" : "Giriş",
    "smartOrderPleaseChoose" : "Seç",
    "smartOrderStoreTime" : "Yükleme Süresi",
    "smartOrderInputOrder" : "Lütfen sipariş numarasını giriniz",
    "smartOrderInputPrice" : "Lütfen sipariş tutarını giriniz",
    "smartOrderNeedHelp" : "Size nasıl yardımcı olabilirim?",
    "smartOrderLookHelpTip" : "SSS bölümüne göz atabilirsiniz.",
    "smartOrderNoResult" : "Sonuç yok. Lütfen başka bir anahtar kelime deneyin.",
    "smartOrderUpdateTime" : "Son düzenleme süresi",
    "smartOrderSelectStoreTime" : "Yükleme süresini seçin",
    "smartOrderAtlestChoose" : "Lütfen en az birini doldurun",
    "pwaInstallAward" : "Kısayol Ekle",
    "getMasonry" : "Elmas Talep Et",
    "addToDrawerVisit" : "Tekrar kolayca bulabilmeniz için bir kısayol ekleyin.",
    "immeAddToGet" : "Sınırlı ödüllerden yararlanmak için şimdi kısayol ekleyin.",
    "add" : "Kısayol Ekle",
    "talkNextTime" : "Sonra",
    "chooseRoleGetGift" : "Ödülleri almak için karakter seç",
    "getGiftSuccess" : "Talep edildi. Oyundaki ödüllerinizi kontrol edin.",
    "dmaTitle" : "Kişiselleştirilmiş Reklamlar",
    "newAdd" : "Yeni",
    "smartDelete" : "Sil",
    "wordLengthTip" : "(0-600 karakter)",
    "areaLimitSwitchRegion" : "Bölge Değiştir",
    "areaLimitCurrentRegionCurrency" : "Mevcut Bölge ve Para Birimi",
    "areaLimitRegion" : "Bölge:",
    "areaLimitCurrency" : "Para Birimi:",
    "areaLimitNote" : "Not:",
    "areaLimitSwitchLimitation" : "Her hesap her yıl bir kez bölge değiştirebilir.",
    "areaLimitPostSwitchCoupon" : "Bölgeniz değiştirildiğinde, yeni kuponların para birimi de buna göre değişecektir.",
    "areaLimitRemainingSwitches" : "Kalan değiştirme hakkı: \${times}",
    "areaLimitNoRemainingSwitches" : "Değiştirme hakkı yok",
    "areaLimitUnableToSwitchThisYear" : "Bu yıl tekrar bölge değiştiremeyebilirsiniz.",
    "areaLimitCannotSwitch" : "Değiştirilemez",
    "areaLimitNavigateToSwitch" : "Değiştir",
    "areaLimitConfirmSwitch" : "Onayla",
    "areaLimitPreSwitchRegionCurrency" : "Mevcut Bölge ve Para Birimi",
    "areaLimitPostSwitchRegionCurrency" : "Yeni Bölge ve Para Birimi",
    "areaLimitPostSwitchRestriction" : "Bir kez yapıldıktan sonra, bu yıl tekrar bölge değiştiremezsiniz.",
    "areaLimitUnusedZBitWarning" : "Bölge değiştirdikten sonra kullanamayacağınız Z-Bit var. Yine de devam et?",
    "areaLimitConfirm" : "Onayla",
    "areaLimitCancel" : "İptal Et",
    "areaLimitInconsistencyWarning" : "Erişim bölgeniz ödeme bölgenizle uyuşmuyor.",
    "areaLimitPromptToSwitch" : "Bölge değiştirmek ister misiniz?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Ödül Talep Et",
    "selectProductTitle" : "Öğe Seçin",
    "hotSuggest" : "Çok Satan",
    "inputKeywordSearch" : "Ara...",
    "lookProductContent" : "Ayrıntılar",
    "popupClose" : "Kapat",
    "productSwitch" : "Değiştir",
    "confirmBuy" : "Satın Al",
    "thinkLater" : "Sonra",
    "areaLimitConfirmRegion" : "Bölgeyi onayla",
    "areaLimitContinuePay" : "Ödemeye devam et",
    "areaLimitSwitchLimitationTwice" : "Her hesap her yıl iki kez bölge değiştirebilir.",
    "dtmslgVipRule1" : "1. Mevcut oyunlar: \${gameName}",
    "dtmslgVipRule2" : "Her tür etkinlik ödülü yalnızca bir kez alınabilir.",
    "dtmslgVipRule3" : "2. VIP Puanları etkinliği: Puan kazanmak ve seviye kuponları ile haftalık kuponlar almak için resmi sayfamız üzerinden öğe satın al.",
    "dtmslgVipRule4" : "3. Kazanabileceğin puanlar kullandığın para birimine göre değişiklik gösterebilir. Daha fazla ayrıntı için lütfen alttaki bağlantıyı kontrol et.",
    "dtmslgVipRule5" : "4. Kupon kullanırken, kuponlar düşüldükten sonra ödediğin tutara göre puan kazanırsın.",
    "dtmslgVipRule6" : "5. Kazandığın puanların süresi 365 gün içinde sona erecek. Bu VIP seviyeni etkileyebilir.",
    "dtmslgVipRule7" : "6. İlk kez bir VIP seviyesine ulaştığın için hemen bir kupon alacaksın. Haftalık kupon her Cumartesi 00:00\'da (UTC+0) alınabilir.",
    "dtmslgVipRule8" : "7. Haftalık kuponu talep etmek için giriş yapman gerekecek. Kaçırma!",
    "dtmslgVipRule9" : "8. Kuponun para birimi, son siparişinin para biriminden olacak. Kullanmakta olduğun para birimini değiştirmek istersen lütfen müşteri hizmetlerimizle iletişime geç.",
    "dtmslgVipRule10" : "9. VIP seviyeleri ve kuponlar hakkında daha fazla ayrıntı için aşağıdaki tabloya bak.",
    "dtmslgVipRule11" : "10. Herhangi bir anlaşmazlık durumunda, \${gameName} destek ekibi bu Hüküm ve Koşulların yorumlanması konusunda yegane ve nihai takdir yetkisine sahiptir.",
    "dtmslgType10010" : "Günlük İndirim",
    "dtmslgType10020" : "Sınırlı Süreli Teklif",
    "dtmslgType10030" : "Kahraman",
    "dtmslgType10040" : "Teçhizat",
    "dtmslgType10050" : "Rün",
    "dtmslgType10060" : "Totem",
    "dtmslgType10070" : "Kutsal Taş",
    "dtmslgType10080" : "Ejder",
    "dtmslgType10090" : "Kaynaklar",
    "dtmslgType10100" : "İnşaat & Teknoloji",
    "dtmslgType10110" : "Nadir",
    "dtmslgType10120" : "Biblo",
    "dtmslgType10130" : "Elmas",
    "dtmslgType10140" : "Kupon",
    "dtmslgType2" : "Etkinlik Paketi",
    "dtmslgType3" : "Ödül Merkezi",
    "dtmslgType4" : "Açılır Pencere Paketi",
    "dtmslgType5" : "Ana Ekran Paketi",
    "dtmslgType20010" : "Kara Cuma Paketi",
    "dtmslgType20021" : "5 Günlük Hediye",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "Bir özellik güncellemesi nedeniyle, \"VIP Puanları\" etkinliği yakında durdurulacaktır.<br/>\n" +
        "VIP Puanları etkinliğinden elde edilen kuponları, geçerlilik süreleri dolmadan önce kullanmayı unutmayın.<br/>\n" +
        "Bitiş Zamanı: 19/08/2024 08.00.00 (UTC)<br/>\n" +
        "Etkinlik sona erdikten sonra, daha fazla avantajdan yararlanmak için Ayrıcalıklı Üyelik Merkezi'ni ziyaret edebilirsiniz:<br/>\n" +
        "Kuponlar, oyun içi öğeler ve diğer ödüllerle takas edilebilen puanlar kazanmak için görevleri tamamlayın! Özel üye avantajlarının ve şanslı çekilişlerin tadını çıkarın.<br/>\n" +
        "Daha fazla ödül ve etkinlik için takipte kalın!",
    "263RightsIntro": "Bir özellik güncellemesi nedeniyle, \"VIP Puanları\" etkinliği yakında durdurulacaktır.<br/>\n" +
        "VIP Puanları etkinliğinden elde edilen kuponları, geçerlilik süreleri dolmadan önce kullanmayı unutmayın.<br/>\n" +
        "Bitiş Zamanı: 28/09/2024 00.00.00 (UTC)<br/>\n" +
        "Etkinlik sona erdikten sonra, daha fazla avantajdan yararlanmak için Ayrıcalıklı Üyelik Merkezi'ni ziyaret edebilirsiniz:<br/>\n" +
        "Kuponlar, oyun içi öğeler ve diğer ödüllerle takas edilebilen puanlar kazanmak için görevleri tamamlayın! Özel üye avantajlarının ve şanslı çekilişlerin tadını çıkarın.<br/>\n" +
        "Daha fazla ödül ve etkinlik için takipte kalın!",
    "goToRights" : "Ayrıcalıklı Üye Merkezine gidin",
    "oldVipIntro" : "VIP Puanları etkinliğinden elde edilen kuponları, geçerlilik süreleri dolmadan önce kullanmayı unutmayın.",
    "pwa-20001" : "Lütfen önce giriş yap",
    "pwa-20002" : "Hatalı parametre",
    "pwa-20003" : "Lütfen bir karakter belirle",
    "pwa-20004" : "Ödüller gönderilemedi. Lütfen tekrar dene veya Müşteri Desteği ile iletişime geç.",
    "pwa-20005" : "Ödülü zaten talep ettin.",
    "pwa-20100" : "Etkinlik başlamadı.",
    "pwa-20101" : "Etkinlik sona erdi.",
    "pwa-20102" : "Ödülleri henüz talep edemezsin.",
    "pwa-20103" : "Ödüllerinin süresi doldu.",
    "pwa-1001" : "Çok sık işlem",
    "pwaCommon" : "Lütfen daha sonra tekrar dene!",
    "zipCodeSwitchZipCode" : "Switch zipcode",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Resmi Yükleme Merkezi",
    "headerSafeTip": "Güvenli ve Risksiz Anında İşlem",
    "safeChecking": "...mevcut ödeme ortamının taranması",
    "safeChecked": "Güvenli, emniyetli kullanım",
    "riskChecked": "Potansiyel risk tespit edildi, dikkatli olun",
    "footerSafeTitle1": "Güvenli",
    "footerSafeTitle2": "Uygun",
    "footerSafeTitle3": "Ekonomik",
    "footerSafeTitle4": "Etkili",
    "footerSafeContent1": "Resmi Yükleme Merkezi",
    "footerSafeContent2": "Birden fazla ödeme yöntemini destekler",
    "footerSafeContent3": "İndirim teklifleri, daha fazla sınırlı süreli avantajlar",
    "footerSafeContent4": "Anında işlem, gecikme yok",
    "limitedTimeActivityTitle" : "Sınırlı Süreli Avantajlar",
    "limitedTimeActivityTime" : "Etkinlik Zamanı:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Mevcut \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Döviz kurları değişiklik gösterebilir, doğru bilgi için lütfen bu sayfaya göz at)",
    "limitedTimeActivityNotAchieve" : "Tamamlanmadı",
    "limitedTimeActivityClaim" : "Al",
    "limitedTimeActivityClaimed" : "Alındı",
    "limitedTimeActivityTimeLeft" : "Sınırlı Süreli: \${days} gün \${hours} sa. \${minutes} dk. \${seconds} sn.",
    "limitedTimeActivityRecord" : "Alınan Ödüller",
    "limitedTimeActivityAward" : "Ödüller",
    "limitedTimeActivityGotTime" : "Alınma Zamanı",
    "limitedTimeActivityGotRole" : "Alınan Karakter",
    "limitedTimeActivityRule" : "Etkinlik Kuralları",
    "limitedTimeActivity285Rule1" : "1. Etkinlik Zamanı:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Etkinlik boyunca ödüller almak için sınırlı süreli görevleri tamamla. Görevler, haftalık ve aylık görevler olarak ikiye ayrılır.",
    "limitedTimeActivity285Rule3" : "(1) Haftalık Görevler: Her hesapta en fazla bir görev tamamlanabilir ve her Pazartesi saat 00.00\'da sıfırlanır.",
    "limitedTimeActivity285Rule4" : "Haftalık Giriş Görevi: Sınırlı süre içinde, resmi web sitesinin yükleme sayfasına bir kez giriş yap.",
    "limitedTimeActivity285Rule5" : "Dilediğin miktarda yükleme yap: Sınırlı süre içinde, resmi web sitesi üzerinden dilediğin miktarda yükleme yap.",
    "limitedTimeActivity285Rule6" : "(2) Aylık Görevler: Her hesapta en fazla bir görev tamamlanabilir ve her ay başı (ayın 1’inde) saat 00.00\'da sıfırlanır.",
    "limitedTimeActivity285Rule7" : "Giriş Görevi: Sınırlı süre içinde, resmi web sitesinin yükleme sayfasına bir kez giriş yap.",
    "limitedTimeActivity285Rule8" : "Toplam Yükleme Görevi: Sınırlı süre içinde, bir kez ödül almak için gerekli tutarda yükleme yap.",
    "limitedTimeActivity285Rule9" : "Not: Etkinliğin uzun sürmesi nedeniyle döviz kurlarında dalgalanma yaşanabilir. Lütfen yükleme tutarı için sayfada gösterilen tutarı baz al.",
    "limitedTimeActivity285Rule10" : "3. Ödül almadan önce bir karakter seç. Ödüllerini aldıktan sonra oyuna giriş yaparak kontrol et.",
    "limitedTimeActivityClaimAward" : "Ödül Al",
    "limitedTimeActivityConfirmGot" : "Onayla",
    "limitedTimeActivityGetSucc" : "Ödül Alındı",
    "limitedTimeActivityGetFail" : "Ödül Alınamadı. Lütfen daha sonra tekrar dene veya müşteri hizmetleriyle iletişime geç.",
    "limitedTimeActivityFrequent" : "Lütfen aşırı sık işlem yapmaktan kaçın.",
    "limitedTimeActivityLoginFirst" : "Lütfen önce giriş yap.",
    "limitedTimeActivityWrongParam" : "Parametre Hatası",
    "limitedTimeActivityOverTips" : "Bu etkinlik sona erdi. Lütfen sayfayı yenile.",
    "preRightsIntro" : "Bir özellik güncellemesi nedeniyle, \"VIP Puanları\" etkinliği yakında durdurulacaktır.<br/>Bitiş Zamanı: \${offLineDate}<br/>VIP Puanları etkinliğinden elde edilen kuponları, geçerlilik süreleri dolmadan önce kullanmayı unutmayın.<br/>Etkinlik sona erdikten sonra, daha fazla avantajdan yararlanmak için Ayrıcalıklı Üyelik Merkezi\'ni ziyaret edebilirsiniz:<br/>Kuponlar, oyun içi öğeler ve diğer ödüllerle takas edilebilen puanlar kazanmak için görevleri tamamlayın! Özel üye avantajlarının ve şanslı çekilişlerin tadını çıkarın.<br/>Daha fazla ödül ve etkinlik için takipte kalın!",
    "riskTipTitle" : "Yasa Dışı Davranışlara ve Dolandırıcılıklara Dikkat Edin",
    "riskTipContent" : "Sevgili Oyuncu,\n\nBazı oyuncuların adil oyun düzenini bozacak şekilde hareket ettiklerini fark ettik. Yaygın ihlaller şunlardır:\n\n1. İzinsiz Reklam Yayınlamak: Oyunda sohbet veya diğer kanallar aracılığıyla yasa dışı kaynak ticareti veya izinsiz bakiye yüklemeleri gibi izinsiz reklamlar paylaşımları.\n2. Hile veya Komut Dosyası Kullanmak: Yasa dışı yollardan kaynak elde etmek için hileler, komut dosyaları veya diğer teknik araçları kullanmak.\n3. İzinsiz Davetler: Sohbet sırasında oyuncuları dış kanallara (örneğin, Line, Discord) çekmek için davetler göndermek.\n4. Yasa Dışı Bakiye Yüklemeleri: Oyuncuları cazip fiyatlarla resmî olmayan bakiye yüklemelerine teşvik etmek.\n5. Diğer Dolandırıcılıklar: Resmî personeli taklit etmek gibi dolandırıcılık faaliyetlerinde bulunmak.\n\nTüm oyuncuları kişisel bilgilerini ve varlıklarını korumaya çağırıyoruz. Yasa dışı veya dolandırıcılıkla ilgili hiçbir mesaja güvenmeyin. Bu ihlaller önemli riskler taşır, bunlar arasında hesap hırsızlığı veya dolandırıcılık faaliyetlerine karışma riski bulunmaktadır. Bu tür eylemlerden kaynaklanan kayıplar için tazmin sağlanmayacağını unutmayın.\n\nBu tür davranışlarda bulunduğu tespit edilen hesaplar için, ihlallerin ciddiyetine ve etkisine bağlı olarak uygun önlemler alınacaktır. Önlemler arasında, bunlarla sınırlı olmamak üzere, uyarılar, yasa dışı kazançlara el koyma, geçici askıya alma veya kalıcı yasaklar yer alabilir. Oyunda herhangi bir şüpheli davranışla karşılaşırsanız, lütfen müşteri destek ekibimize bildirin. Mümkün olan en kısa sürede araştıracak ve gerekli önlemleri alacağız. Anlayışınız ve desteğiniz için teşekkür ederiz.",
    "linkValid": "Bağlantı süresi doldu",
    "-" : "-",
    "accountLabel": "Hesap",
    "passwordLabel": "Şifre",
    "confirmPasswordLabel": "Şifreyi Onayla",
    "confirmDeleteTitle" : "Hesabınızı ve tüm karakterlerinizi silmek istediğinizden emin misiniz?",
    "confirmDeleteYes" : "Evet. Hesabımı ve tüm karakterlerimi silmek istiyorum.",
    "selectGame" : "Oyun Seç",
    "confirmDeleteNo" : "Hayır. Sadece bir karakteri silmek istiyorum. Hesabımı tutmak istiyorum.",
    "delTermsTitle" : "Hesap silme gereksinimlerini ve bildirimi dikkatlice okuyun.",
    "delCondTitle" : "1. Hesap Silme Gereksinimleri",
    "delCond1" : "(1) Başvurmadan önce hesabınıza giriş yapın. Giriş yapamıyorsanız, önce [hesabı kurtar]. Oyun hesabının ve karakterinin size ait olduğundan emin olun.",
    "delCond2" : "(2) Hesabınızın ve karakterinizin <span>hiçbir güvenlik riski</span> taşımadığını, çözülmemiş şikayetler, raporlar, soruşturmalar, ara buluculuklar veya davalar (sizin tarafınızdan veya aleyhinize açılmış) bulunmadığını onaylayın.",
    "delCond3" : "(3) Hesabınızın ve karakterinizin çözülmemiş iadeler veya aktif abonelikler dahil <span>bekleyen ödemesi</span> olmadığını onaylayın.",
    "delNoticeTitle" : "2. Hesap Silme Bildirimi",
    "delNotice1" : "(1) Bu oyun hesabının ve ona bağlı karakterlerin silinmesi <span>kalıcı ve geri alınamaz</span> olacaktır.",
    "delNotice2" : "(2) Hesap silindiğinde kalıcı olarak silineceğinden, lütfen devam etmeden önce öğeler, para birimi ve abonelikler dahil ancak bunlarla sınırlı olmamak üzere tüm ödenmemiş <span>oyun içi varlıkları halledin</span>. Silinen hesaplar veya karakterler için oyun sunucusu kapatıldıktan sonra geri ödeme yapılmayacaktır.",
    "delNotice3" : "(3) Hesap ve karakter verilerinin silinmesi, ilgili tüm bilgilerin kaldırılmasına veya anonimleştirilmesine yol açacaktır. Ancak, üçüncü taraf sosyal medya girişleriyle (örneğin Facebook) ilişkilendirilen verileri manuel olarak ayırmanız ve yönetmeniz gerekecektir.",
    "delNotice4" : "(4) Çıkarlarınızı korumak için (yerel düzenlemelerin farklı olduğu durumlar hariç), silme talebini iptal etmek için müşteri desteğiyle iletişime geçebileceğiniz 14 günlük bir cayma süresi (Cayma Süresi) sağlanır.",
    "delNotice5" : "(5) Başvuru başarıyla gönderildiğinde, hesabınız hemen dondurulacak ancak veri silme işlemi bir hafta sürebilir. Tamamlandığında bir e-posta bildirimi alacaksınız.",
    "delFormConfirm1" : "Hesap silme koşullarını ve sonuçlarını anladım.",
    "delFormConfirm2" : "Bu hesapta açık bir rapor veya dava yoktur.",
    "delForm" : "<a class=\"account-delete-link\" href=\"javascript:;\">Hesap Fesih Sözleşmesini</a> okudum ve kabul ediyorum.",
    "cannotDeleteMsgTitle" : "Hesap silinemiyor",
    "cannotDeleteMsg1" : "Hesabınız, silme gereksinimlerini karşılamıyor:",
    "cannotDeleteMsg2" : "Çözülmemiş destek talepleriniz var. Tekrar başvurmadan önce bunları çözün.",
    "cannotDeleteMsg3" : "Bekleyen iadeleriniz var. Lütfen hesap silme başvurusu yapmadan önce bunları çözün.",
    "cannotDeleteMsg4" : "Hesabınız, oyuncu raporları veya şikayetleri nedeniyle şu anda inceleme altındadır. Lütfen incelemenin tamamlanmasını bekleyin ve ardından tekrar başvurun.",
    "formCompleted" : "Destek Talebi Gönderildi",
    "formCheckMsg1" : "Destek talebiniz gönderildi, lütfen inceleme ve yanıt için bekleyin.",
    "formCheckMsg2" : "Destek talebinizin ilerlemesini <span class=\"account-delete-link\">[Taleplerim]</span> kısmından kontrol edebilirsiniz.",
    "delEmailMsg1" : "Silme işlemi sonrası e-posta ile bilgilendirme ister misiniz?",
    "delEmailMsg2" : "Hesap silme işlemi, veri işleme nedeniyle yaklaşık bir hafta sürecektir. Tamamlandığında e-posta ile bilgilendirme almak ister misiniz?",
    "delEmailMsg3" : "E-posta adresiniz yalnızca bilgilendirme amaçlarıyla kullanılacaktır.",
    "delEmailConfirmYes" : "Evet, e-posta ile bilgilendirin.",
    "delEmailFill" : "Bildirim e-posta adresinizi girin.",
    "delEmailConfirmNo" : "Hayır, e-posta bildirimi istemiyorum.",
    "delCoolMsg1" : "14 günlük cayma süresi ister misiniz?",
    "delCoolMsg2" : "14 günlük cayma süresi boyunca hesabınız dondurulacak, ancak silme işlemini iptal etmek için herhangi bir zamanda talep gönderebilirsiniz. 14 gün sonra, eğer iptal etmediyseniz, hesabınız silinecek ve geri alınamayacaktır.",
    "delCoolMsg3" : "Cayma süresi istemezseniz, başvuru tamamlandıktan hemen sonra hesabınız silinecek ve geri alınamayacaktır.",
    "delCoolConfirmYes" : "Evet, 14 günlük cayma süresi istiyorum.",
    "delCoolConfirmNo" : "Hayır, hemen silinsin.",
    "delSecondCheckMsg1" : "Tüm hesap içeriklerini işlediğinize ve hesap cayma süresini etkinleştirmek istediğinize emin misiniz? Etkinleştirmeden sonra hesabınıza erişilemeyecektir.",
    "delSecondCheckConfirmYes" : "Evet, şimdi etkinleştir.",
    "delResMsg1" : "Hesap silme talebiniz gönderildi ve aşağıdaki hesap donduruldu:",
    "gameName" : "Oyun Adı:",
    "gameAccount" : "Oyun Hesabı:",
    "delResMsg2" : "<span>Yukarıdaki hesap bilgilerini ekran görüntüsü alarak kaydedin, çünkü bu cayma süresi boyunca hesabınızı geri yüklemeniz gerektiğinde tek doğrulama olacaktır</span>.",
    "delResMsg3" : "Cayma süresi: 14 gün. Kalan süre:",
    "delResMsg4" : "Cayma süresi boyunca silme talebini iptal etmek için tıklayın: [Destekle İletişime Geç]",
    "copyAccountInfo" : "Hesap bilgilerini kopyala",
    "delResMsg5" : "Hesap silme talebiniz işleme alındı ve hesabınız şu anda siliniyor. Bu nedenle artık hesabınıza giriş yapamazsınız.",
    "delResMsg6" : "Hesap silme işlemi büyük miktarda veri içerdiği için bir süre alacaktır. Bu nedenle, hesabınıza ait tüm izler hemen silinmeyecektir. Bu işlemin yaklaşık bir hafta içinde tamamlanmasını bekliyoruz.",
    "delResMsg7" : "Eğer daha önce bir bildirim e-posta adresi sağladıysanız, bu adrese bir e-posta göndereceğiz.",
    "delResMsg8" : "Eğer oyuna tekrar giriş yapmak isterseniz, yeni bir hesap kaydedebilirsiniz.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Diğer Kanallar",
    "itemWrong" : "Girişinizle ilgili bir hata oluştu. Tekrar deneyin.",
    "delRegisterTime" : "Kayıt Tarihi",
    "delDevice" : "Sık Kullanılan Cihaz",
    "delIp" : "Sık Kullanılan IP Adresi",
    "delHistoryPayChannel" : "Tarihsel Yeniden Yükleme Kanalları",
    "delHistoryPayOrder" : "Geçmiş Sipariş Numarası",
    "delDeleteReason" : "Hesap Silme Nedeni",
    "delPrevStep" : "Önceki",
    "delNextStep" : "Sonraki",
    "delSecondCheckMsg2" : "Tüm hesap içeriğini işlediğinize ve şimdi hesap silme işlemine devam etmek istediğinize emin misiniz? İşlem gerçekleştirildikten sonra, artık hesabınıza erişilemeyecektir.",
    "pleaseFillIn" : "Lütfen aşağıdaki bilgileri sağlayın",
    "switchNewVersion": "Yeni Ödeme",
    "switchNewVersionPlatform": "Platformuna Geç",
    "updateVersionPopupContent": "Daha akıcı oyun performansı ve gelecekteki yeni özelliklerin desteklenmesi için cihazınızın sistemini yükseltmenizi öneririz. Bu, daha istikrarlı bir çalışma deneyimi ve uyumluluk optimizasyonu sağlar.",
    selectTopupTips:"Kullanıcıların %90'ı resmi ödeme merkezini tercih ediyor",
    chuzhi: "Bakiye yükleme",
    selectMethods: "Ödeme Yöntemi",
    v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox'
}